import L, { FeatureGroup, LatLngExpression } from 'leaflet';
import 'leaflet/dist/leaflet.css'
import JSZip from 'jszip';
import { ChangeEvent, MutableRefObject } from 'react';
import * as shapefile from 'shapefile';
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import togeojson from 'togeojson';
import * as shp from '@mapbox/shp-write';
import * as turf from '@turf/turf'
import { ReactComponent as Marker } from '../images/map-marker-multiple-svgrepo-com.svg';
import { renderToString } from 'react-dom/server';
import Marker_PNG from '../images/map-marker-multiple-svgrepo-com.png'
import { Dbf } from 'dbf-reader';
import { DataTable } from 'dbf-reader/models/dbf-file';
import { Buffer } from 'buffer';
import 'leaflet-groupedlayercontrol';
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.css';
import 'leaflet.locatecontrol'; // Importa o JS
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css'; // Importa o CSS
import { ImovelType } from '../db/Orm';

// const att = '<a href="http://www.damine.com.br">Damine</a> &copy;';
const att = 'Gearspark &copy;';
export type ButtonMap = {
    icon: string
    func: Function
}
export const mapas =
{
    openStreetMap: () => {
        return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: att
        })
    },
    openStreetMap_hot: () => {
        return L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: att
        })
    },
    openStreetMap_topo: () => {
        return L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: att
        })
    },
    cartocdn: () => {
        return L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: att
        })
    },
    googleSat: () => {
        return L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: att
        })
    },
    googleTerrain: () => {
        return L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: att
        })
    },
    googleHybrid: () => {
        return L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: att
        })
    },
    googleStreets: () => {
        return L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: att
        })
    },
    ows_topo: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'TOPO-WMS',
            attribution: att
        })
    },
    ows_topo_wms: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'TOPO-OSM-WMS',
            attribution: att
        })
    },
    ows_places: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'OSM-Overlay-WMS',
            attribution: att
        })
    },
    ows_topo_places: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'TOPO-WMS,OSM-Overlay-WMS',
            attribution: att
        })
    },
    ows_places_topo: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'OSM-Overlay-WMS,TOPO-WMS',
            attribution: att
        })
    },
    ows_srtm: () => {
        return L.tileLayer.wms('http://ows.mundialis.de/services/service?', {
            layers: 'SRTM30-Colored-Hillshade',
            attribution: att
        })
    },
    arcgis: () => {
        return L.tileLayer('https://{s}.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            className: "basemap",
            maxNativeZoom: 17,
            maxZoom: 17,
            subdomains: ["clarity"],
            // attribution="Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community"
            attribution: att
        })
    },
    arcgis2: () => {
        return L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        })
    },
    arcgis3: () => {
        return L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places_Alternate/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Labels &copy; Esri &mdash; Source: Esri'
        })
    },
    nexrad: () => {
        return L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
            layers: 'nexrad-n0r-900913',
            format: 'image/png',
            transparent: true,
            attribution: "Weather data © 2012 IEM Nexrad"
        });
    },
    gebco: () => {
        return L.tileLayer.wms("https://wms.gebco.net/mapserv?", {
            layers: 'nexrad-n0r-900913',
            format: 'image/png',
            transparent: true,
            attribution: "Weather data © 2012 IEM Nexrad"
        });
    },
    esri: () => {
        return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
        })
    },
    stamenToner: () => {
        return L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png', {
            attribution: 'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under ODbL.'
        })
    },
    sentinelTrue: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '1_TRUE_COLOR', // Example layer
            format: 'image/png',
            maxZoom: 18,
        })
    },
    sentinelTrueL1C: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '1_TRUE-COLOR-L1C', // Example layer
            format: 'image/png',
            maxZoom: 18,
        })
    },
    sentinelFalse: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '2_FALSE_COLOR', // Example layer
            format: 'image/png',
            maxZoom: 18,
        })
    },
    sentinelFalseL1C: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '2_FALSE-COLOR-L1C', // Example layer
            format: 'image/png',
            maxZoom: 18,
        })
    },
    sentinelNDVI: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '3_NDVI',
            format: 'image/png',
            maxZoom: 20,
        })
    },
    sentinelNDVIL1C: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '3_NDVI-L1C',
            format: 'image/png',
            maxZoom: 20,
        })
    },
    sentinelSWIR: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '6-SWIR-L1C',
            format: 'image/png',
            maxZoom: 20,
        })
    },
    sentinelNDWI: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: '7-NDWI-L1C',
            format: 'image/png',
            maxZoom: 20,
        })
    },
    sentinel1: () => {
        return L.tileLayer.wms('https://services.sentinel-hub.com/ogc/wms/89865c9d-d399-4129-8d5a-f75f921e87be', {
            layers: 'SENTINEL-1',
            format: 'image/png',
            maxZoom: 20,
        })
    },
    biomas: (layer: string) => {
        return L.tileLayer.wms('https://shared-geoserver.mapbiomas.org/geoserver/mapbiomas-layers/ows', {
            layers: 'mapbiomas-layers:' + layer,
            format: 'image/png',
            transparent: true,
            maxZoom: 20,
        })
    },
    // 2. NOVA função para WFS (polígonos interativos)
    biomas_interactive: (layerName: string) => {
        const fullLayerName = 'mapbiomas-layers:' + layerName;
        const wfsUrl = `https://shared-geoserver.mapbiomas.org/geoserver/mapbiomas-layers/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=${fullLayerName}&outputFormat=application/json`;

        const geoJsonLayer = L.geoJSON(undefined, {
            onEachFeature: (feature, layer) => {
                const properties = feature.properties;
                let popupContent = `<h4>${layerName.replace(/_/g, ' ')}</h4><hr>`;
                for (const key in properties) {
                    if (properties.hasOwnProperty(key)) {
                        popupContent += `<strong>${key}:</strong> ${properties[key]}<br>`;
                    }
                }
                layer.bindPopup(popupContent);
            },
            style: {
                color: "#9932CC", // Roxo para diferenciar
                weight: 2,
                opacity: 1,
                fillOpacity: 0.4
            }
        });

        fetch(wfsUrl)
            .then(response => response.json())
            .then(data => {
                geoJsonLayer.addData(data);
            })
            .catch(error => console.error(`Erro ao buscar dados WFS para a camada ${layerName}:`, error));

        return geoJsonLayer;
    },
    biomas_layers: [
        'watersheds',
        'deforestation_authorizations_old',
        'embargoed_areas',
        'management_plan',
        'amacro',
        'atlantic_forest_law',
        'biomes',
        'biosphere_reserve',
        'conservation_units',
        'country',
        'deforestation_authorizations',
        'deforestation_authorizations_federal',
        'deforestation_authorizations_states',
        'embargoed_areas_federal',
        'embargoed_areas_states',
        'forest_concessions',
        'geoparks',
        'indigenous_territories',
        'legal_amazon',
        'management_plan_federal',
        'marine_coastal_system',
        'matopiba',
        'municipalities',
        'permanent_protected_areas',
        'pnrh_level_1_basin',
        'pnrh_level_2_basin',
        'priority_bio_conservation_areas',
        'quilombos',
        'semiarid',
        'settlements',
        'sicar',
        'sigef',
        'snci',
        'states'],


    embrapa: () => {
        return L.tileLayer.wms('https://geoinfo.dados.embrapa.br/geoserver/ows', {
            format: 'image/png',
            // transparent: true,
            maxZoom: 20,
        })
    },
    terrabrasilis_wms_layers: [
        // { name: 'biome_border', description: 'Biome border' },
        // { name: 'terraclass-cerrado:TC_18_LN_landsat_4674', description: 'TC_18_LN_landsat_4674' },
        // { name: 'prodes-pampa-nb:accumulated_deforestation_2000', description: 'Accumulated Deforestation in Pampa biome - 2000' },
        // { name: 'prodes-pantanal-nb:accumulated_deforestation_2000', description: 'Accumulated Deforestation in Pantanal biome - 2000' },
        // { name: 'prodes-caatinga-nb:accumulated_deforestation_2000', description: 'Accumulated Deforestation in Caatinga biome - 2000' },
        // { name: 'prodes-mata-atlantica-nb:accumulated_deforestation_2000', description: 'Accumulated Deforestation in MataAtlantica biome - 2000' },
        // { name: 'prodes-cerrado-nb:accumulated_deforestation_2000', description: 'Accumulated deforestation in the Cerrado Biome until 2000' },
        // { name: 'prodes-legal-amz:accumulated_deforestation_2007', description: 'Accumulated Deforestation in Legal Amazon - 2007' },
        // { name: 'prodes-amazon-nb:accumulated_deforestation_2007_biome', description: 'Accumulated Deforestation in Amazon Biome - 2007' },
        // { name: 'ams1h_auth:active-fire', description: 'active-fire 1ha' },
        // { name: 'ams1h:active-fire', description: 'active-fire 1h' },
        // { name: 'amsh:active-fire', description: 'active-fire' },
        // { name: 'ams1_auth:active-fire', description: 'active-fire 1a' },
        // { name: 'ams1:active-fire', description: 'active-fire 1a' },
        // { name: 'tcc-samples:alto_parnaiba', description: 'Alto Parnaíba - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:alto_parnaiba', description: 'alto_parnaiba' },
        // { name: 'tcc-samples:alto_sao_francisco', description: 'Alto São Francisco - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:alto_sao_francisco', description: 'alto_sao_francisco' },
        // { name: 'prodes-amazon-nb:amazon_biome_border', description: 'Brazilian Amazon Biome border' },
        // { name: 'tcc-samples:araguaia_tocantins', description: 'Araguaia Tocantins - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:araguaia_tocantins', description: 'araguaia_tocantins' },
        // { name: 'tcc-samples:bananal', description: 'Bananal - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:bananal', description: 'bananal' },
        // { name: 'tcc-samples:basaltos_do_parana', description: 'Basaltos do Paraná - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:basaltos_do_parana', description: 'basaltos_do_parana' },
        // { name: 'tcc-samples:bico_do_papagaio', description: 'Bico do Papagaio - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:bico_do_papagaio', description: 'bico_do_papagaio' },
        { name: 'prodes-brasil-nb:biomas_brasil', description: 'Brazilian biome border' },
        // { name: 'ams1h_auth:biome_border', description: 'biome_border' },
        // { name: 'ams1h:biome_border', description: 'biome_border' },
        // { name: 'amsh:biome_border', description: 'biome_border' },
        // { name: 'prodes-pampa-nb:biome_border', description: 'Biome border' },
        // { name: 'prodes-pantanal-nb:biome_border', description: 'Biome border' },
        // { name: 'prodes-caatinga-nb:biome_border', description: 'Biome border' },
        // { name: 'prodes-mata-atlantica-nb:biome_border', description: 'Biome border' },
        // { name: 'ams1_auth:biome_border', description: 'biome_border' },
        // { name: 'ams1:biome_border', description: 'biome_border' },
        // { name: 'prodes-cerrado-nb:biome_border', description: 'Brazilian Cerrado Biome border' },
        // { name: 'prodes-legal-amz:brazilian_legal_amazon', description: 'Brazilian Legal Amazon' },
        // { name: 'tcc-samples:cell_0_01_amostras', description: 'cell_0_01_amostras' },
        // { name: 'tcc-samples:centro-norte_piauiense', description: 'Centro-norte Piauiense - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:centro_norte_piauiense', description: 'centro_norte_piauiense' },
        // { name: 'tcc-samples:chapada_dos_parecis', description: 'Chapada dos Parecis - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:chapada_dos_parecis', description: 'chapada_dos_parecis' },
        // { name: 'tcc-samples:chapadao_do_sao_francisco', description: 'Chapadão do São Francisco - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:chapadao_do_sao_francisco', description: 'chapadao_do_sao_francisco' },
        // { name: 'prodes-legal-amz:cloud', description: 'Cloud since 2016' },
        // { name: 'prodes-pampa-nb:cloud', description: 'Cloud since 2000' },
        // { name: 'prodes-pantanal-nb:cloud', description: 'Cloud since 2000' },
        // { name: 'prodes-caatinga-nb:cloud', description: 'Cloud since 2000' },
        // { name: 'prodes-mata-atlantica-nb:cloud', description: 'Cloud since 2000' },
        // { name: 'prodes-amazon-nb:cloud_biome', description: 'Cloud since 2016' },
        // { name: 'tcc-samples:complexo_bodoquena', description: 'Complexo Bodoquena - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:complexo_bodoquena', description: 'complexo_bodoquena' },
        // { name: 'prodes-amazon-nb:conservation_units_amazon_biome', description: 'Conservation Units Amazon Biome' },
        // { name: 'prodes-caatinga-nb:conservation_units_caatinga_biome', description: 'Conservation units caatinga biome' },
        // { name: 'prodes-cerrado-nb:conservation_units_cerrado_biome', description: 'Conservation Units in the Cerrado Biome' },
        // { name: 'prodes-legal-amz:conservation_units_legal_amazon', description: 'Conservation Units Legal Amazon' },
        // { name: 'prodes-mata-atlantica-nb:conservation_units_mata_atlantica_biome', description: 'Conservation units mata_atlantica biome' },
        // { name: 'prodes-pampa-nb:conservation_units_pampa_biome', description: 'Conservation units pampa biome' },
        // { name: 'prodes-pantanal-nb:conservation_units_pantanal_biome', description: 'Conservation units pantanal biome' },
        // { name: 'tcc-samples:costeiro', description: 'Costeiro - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:costeiro', description: 'costeiro' },
        // { name: 'ams:csAmz_150km_view', description: 'csAmz_150km_view' },
        // { name: 'ams:csAmz_25km_view', description: 'csAmz_25km_view' },
        // { name: 'ams1h_auth:cs_150km_diff_view', description: 'cs_150km_diff_view' },
        // { name: 'ams1h:cs_150km_diff_view', description: 'cs_150km_diff_view' },
        // { name: 'amsh:cs_150km_diff_view', description: 'cs_150km_diff_view' },
        // { name: 'ams1_auth:cs_150km_diff_view', description: 'cs_150km_diff_view' },
        // { name: 'ams1:cs_150km_diff_view', description: 'cs_150km_diff_view' },
        // { name: 'ams1h_auth:cs_150km_view', description: 'cs_150km_view' },
        // { name: 'ams1h:cs_150km_view', description: 'cs_150km_view' },
        // { name: 'amsh:cs_150km_view', description: 'cs_150km_view' },
        // { name: 'ams1_auth:cs_150km_view', description: 'cs_150km_view' },
        // { name: 'ams1:cs_150km_view', description: 'cs_150km_view' },
        // { name: 'ams1h_auth:cs_25km_diff_view', description: 'cs_25km_diff_view' },
        // { name: 'ams1h:cs_25km_diff_view', description: 'cs_25km_diff_view' },
        // { name: 'amsh:cs_25km_diff_view', description: 'cs_25km_diff_view' },
        // { name: 'ams1_auth:cs_25km_diff_view', description: 'cs_25km_diff_view' },
        // { name: 'ams1:cs_25km_diff_view', description: 'cs_25km_diff_view' },
        // { name: 'ams1h_auth:cs_25km_view', description: 'cs_25km_view' },
        // { name: 'ams1h:cs_25km_view', description: 'cs_25km_view' },
        // { name: 'amsh:cs_25km_view', description: 'cs_25km_view' },
        // { name: 'ams1_auth:cs_25km_view', description: 'cs_25km_view' },
        // { name: 'ams1:cs_25km_view', description: 'cs_25km_view' },
        // { name: 'ams1h_auth:cs_5km_diff_view', description: 'cs_5km_diff_view' },
        // { name: 'ams1h:cs_5km_diff_view', description: 'cs_5km_diff_view' },
        // { name: 'ams1_auth:cs_5km_diff_view', description: 'cs_5km_diff_view' },
        // { name: 'ams1:cs_5km_diff_view', description: 'cs_5km_diff_view' },
        // { name: 'ams1h_auth:cs_5km_view', description: 'cs_5km_view' },
        // { name: 'ams1h:cs_5km_view', description: 'cs_5km_view' },
        // { name: 'ams1_auth:cs_5km_view', description: 'cs_5km_view' },
        // { name: 'ams1:cs_5km_view', description: 'cs_5km_view' },
        // { name: 'tcc-samples:depressao_carstica_do_sao_francisco', description: 'Depressão Cárstica do São Francisco - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:depressao_carstica_do_sao_francisco', description: 'depressao_carstica_do_sao_francisco' },
        // { name: 'tcc-samples:depressao_cuiabana', description: 'Depressão Cuiabana - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:depressao_cuiabana', description: 'depressao_cuiabana' },
        // { name: 'ams1h_auth:deter-ams', description: 'deter-ams' },
        // { name: 'ams1h:deter-ams', description: 'deter-ams' },
        // { name: 'ams1_auth:deter-ams', description: 'deter-ams' },
        // { name: 'ams1:deter-ams', description: 'deter-ams' },
        // { name: 'amsh:deter_ams', description: 'deter_ams' },
        // { name: 'deter-amz:deter_amz', description: 'DETER Daily - Anonymous' },
        // { name: 'deter-cerrado-nb:deter_cerrado', description: 'DETER Daily - Anonymous' },
        // { name: 'vegetation-cerrado:ecoregions', description: 'Cerrado Biome Ecoregions' },
        // { name: 'tcc-samples:floresta_de_cocais', description: 'Floresta de Cocais - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:floresta_de_cocais', description: 'floresta_de_cocais' },
        // { name: 'queimadas:focos_48h_br_todosats', description: 'focos_48h_br_todosats' },
        // { name: 'prodes-legal-amz:forest', description: 'Forest since 2016' },
        // { name: 'prodes-amazon-nb:forest_biome', description: 'Forest since 2016' },
        // { name: 'prodes-legal-amz:hydrography', description: 'Hydrography' },
        // { name: 'prodes-pampa-nb:hydrography', description: 'Hydrography' },
        // { name: 'prodes-pantanal-nb:hydrography', description: 'Hydrography' },
        // { name: 'prodes-caatinga-nb:hydrography', description: 'Hydrography' },
        // { name: 'prodes-mata-atlantica-nb:hydrography', description: 'Hydrography' },
        // { name: 'prodes-cerrado-nb:hydrography', description: 'Hydrographic data of the Cerrado Biome' },
        // { name: 'vegetation-cerrado:hydrography', description: 'Hydrographic Grid in the Cerrado Biome' },
        // { name: 'prodes-amazon-nb:hydrography_biome', description: 'Hydrography' },
        // { name: 'prodes-amazon-nb:indigenous_area_amazon_biome', description: 'Indigenous Area Amazon Biome' },
        // { name: 'prodes-caatinga-nb:indigenous_area_caatinga_biome', description: 'Indigenous area caatinga biome' },
        // { name: 'prodes-cerrado-nb:indigenous_area_cerrado_biome', description: 'Indigenous Area in the Cerrado Biome' },
        // { name: 'prodes-legal-amz:indigenous_area_legal_amazon', description: 'Indigenous Area Legal Amazon' },
        // { name: 'prodes-mata-atlantica-nb:indigenous_area_mata_atlantica_biome', description: 'Indigenous area mata_atlantica biome' },
        // { name: 'prodes-pampa-nb:indigenous_area_pampa_biome', description: 'Indigenous area pampa biome' },
        // { name: 'prodes-pantanal-nb:indigenous_area_pantanal_biome', description: 'Indigenous area pantanal biome' },
        // { name: 'tcc-samples:jequitinhonha', description: 'Jequitinhonha - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:jequitinhonha', description: 'jequitinhonha' },
        // { name: 'prodes-amazon-nb:municipalities_amazon_biome', description: 'Municipalities Amazon Biome' },
        // { name: 'ams1h_auth:municipalities_border', description: 'municipalities_border' },
        // { name: 'ams1h:municipalities_border', description: 'municipalities_border' },
        // { name: 'amsh:municipalities_border', description: 'municipalities_border' },
        // { name: 'ams1_auth:municipalities_border', description: 'municipalities_border' },
        // { name: 'ams1:municipalities_border', description: 'municipalities_border' },
        // { name: 'prodes-caatinga-nb:municipalities_caatinga_biome', description: 'Municipalities caatinga biome' },
        // { name: 'prodes-cerrado-nb:municipalities_cerrado_biome', description: 'Municipalities of the Cerrado Biome' },
        // { name: 'ams1h_auth:municipalities_diff_view', description: 'municipalities_diff_view' },
        // { name: 'ams1h:municipalities_diff_view', description: 'municipalities_diff_view' },
        // { name: 'amsh:municipalities_diff_view', description: 'municipalities_diff_view' },
        // { name: 'ams1_auth:municipalities_diff_view', description: 'municipalities_diff_view' },
        // { name: 'ams1:municipalities_diff_view', description: 'municipalities_diff_view' },
        // { name: 'prodes-legal-amz:municipalities_legal_amazon', description: 'Municipalities Legal Amazon' },
        // { name: 'prodes-mata-atlantica-nb:municipalities_mata_atlantica_biome', description: 'Municipalities mata_atlantica biome' },
        // { name: 'prodes-pampa-nb:municipalities_pampa_biome', description: 'Municipalities pampa biome' },
        // { name: 'prodes-pantanal-nb:municipalities_pantanal_biome', description: 'Municipalities pantanal biome' },
        // { name: 'ams1h_auth:municipalities_view', description: 'municipalities_view' },
        // { name: 'ams1h:municipalities_view', description: 'municipalities_view' },
        // { name: 'amsh:municipalities_view', description: 'municipalities_view' },
        // { name: 'ams1_auth:municipalities_view', description: 'municipalities_view' },
        // { name: 'ams1:municipalities_view', description: 'municipalities_view' },
        // { name: 'terraclass-cerrado:natural_vegetation', description: 'Natural vegetation in cerrado at 2020' },
        // { name: 'prodes-legal-amz:no_forest', description: 'No Forest' },
        // { name: 'prodes-amazon-nb:no_forest_biome', description: 'No Forest for biome' },
        // { name: 'tcc-samples:paracatu', description: 'Paracatu - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:paracatu', description: 'paracatu' },
        // { name: 'tcc-samples:parana_guimaraes', description: 'Paraná Guimarães - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:parana_guimaraes', description: 'parana_guimaraes' },
        // { name: 'tcc-samples:parnagua', description: 'Parnaguá - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:parnagua', description: 'parnagua' },
        // { name: 'tcc-samples:planalto_central', description: 'Planalto Central - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:planalto_central', description: 'planalto_central' },
        // { name: 'prodes-brasil-nb:prodes_brasil', description: 'PRODES Brazil' },
        // { name: 'prodes-legal-amz:residual', description: 'Residual deforestation in the Legal Amazon' },
        // { name: 'prodes-caatinga-nb:residual', description: 'Residual deforestation in the Caatinga Biome' },
        // { name: 'prodes-mata-atlantica-nb:residual', description: 'Residual deforestation in the Mata Atlântica Biome' },
        // { name: 'prodes-cerrado-nb:residual', description: 'Residual deforestation in the Cerrado Biome' },
        // { name: 'prodes-amazon-nb:residual_biome', description: 'Residual deforestation in the Amazon Biome' },
        // { name: 'ams1h_auth:risk-ibama-weekly-data', description: 'risk-ibama-weekly-data' },
        // { name: 'ams1_auth:risk-ibama-weekly-data', description: 'risk-ibama-weekly-data' },
        // { name: 'ams1h_auth:risk-inpe-data', description: 'risk-inpe-data' },
        // { name: 'ams1h:risk-inpe-data', description: 'risk-inpe-data' },
        // { name: 'vegetation-cerrado:srtm_relief_shading', description: 'SRTM shaded relief for the Cerrado Biome' },
        // { name: 'prodes-amazon-nb:states_amazon_biome', description: 'States Amazon Biome' },
        // { name: 'prodes-caatinga-nb:states_caatinga_biome', description: 'States caatinga biome' },
        // { name: 'prodes-cerrado-nb:states_cerrado_biome', description: 'Brazilian states in the Cerrado Biome' },
        // { name: 'ams1h_auth:states_diff_view', description: 'states_diff_view' },
        // { name: 'ams1h:states_diff_view', description: 'states_diff_view' },
        // { name: 'amsh:states_diff_view', description: 'states_diff_view' },
        // { name: 'ams1_auth:states_diff_view', description: 'states_diff_view' },
        // { name: 'ams1:states_diff_view', description: 'states_diff_view' },
        // { name: 'prodes-legal-amz:states_legal_amazon', description: 'States Legal Amazon' },
        // { name: 'prodes-mata-atlantica-nb:states_mata_atlantica_biome', description: 'States mata_atlantica biome' },
        // { name: 'prodes-pampa-nb:states_pampa_biome', description: 'States pampa biome' },
        // { name: 'prodes-pantanal-nb:states_pantanal_biome', description: 'States pantanal biome' },
        // { name: 'ams1h_auth:states_view', description: 'states_view' },
        // { name: 'ams1h:states_view', description: 'states_view' },
        // { name: 'amsh:states_view', description: 'states_view' },
        // { name: 'ams1_auth:states_view', description: 'states_view' },
        // { name: 'ams1:states_view', description: 'states_view' },
        // { name: 'prodes-amazon-nb:temporal_mosaic_amazon_nf', description: 'Non-forest Amazon Temporal Mosaic' },
        // { name: 'prodes-amazon-nb:temporal_mosaic_amz_biome', description: 'Amazon Biome Mosaic' },
        // { name: 'prodes-caatinga-nb:temporal_mosaic_caatinga', description: 'Caatinga Mosaic' },
        // { name: 'terraclass-cerrado:temporal_mosaic_cerrado', description: 'Cerrado Mosaic' },
        // { name: 'prodes-cerrado-nb:temporal_mosaic_cerrado', description: 'Cerrado Mosaic' },
        // { name: 'terraclass-cerrado:temporal_mosaic_cerrado_2020', description: 'Cerrado Mosaic 2020' },
        // { name: 'terraclass-cerrado:temporal_mosaic_cerrado_2020_hybrid', description: 'Cerrado Mosaic 2020 Hybrid' },
        // { name: 'terraclass-cerrado:temporal_mosaic_cerrado_2022', description: 'Cerrado Mosaic 2022' },
        // { name: 'terraclass-cerrado:temporal_mosaic_cerrado_2022_bdc', description: 'Cerrado Mosaic 2022 bdc' },
        // { name: 'prodes-legal-amz:temporal_mosaic_legal_amazon', description: 'Legal Amazon Mosaic' },
        // { name: 'prodes-mata-atlantica-nb:temporal_mosaic_mata_atlantica', description: 'Mata Atlantica Mosaic' },
        // { name: 'prodes-pampa-nb:temporal_mosaic_pampa', description: 'Pampa Mosaic' },
        // { name: 'prodes-pantanal-nb:temporal_mosaic_pantanal', description: 'Pantanal Mosaic' },
        // { name: 'tcc-samples:vao_do_parana', description: 'Vão do Paranã - Cerrado ecoregion' },
        // { name: 'vegetation-cerrado:vao_do_parana', description: 'vao_do_parana' },
        // { name: 'vegetation-cerrado:vegetation_types', description: 'Vegetation types for all ecoregions in the Cerrado Biome' },
        // { name: 'prodes-legal-amz:yearly_deforestation', description: 'Yearly deforestation since 2008' },
        // { name: 'prodes-pampa-nb:yearly_deforestation', description: 'Yearly deforestation biome since 2004' },
        // { name: 'prodes-pantanal-nb:yearly_deforestation', description: 'Yearly deforestation biome since 2004' },
        // { name: 'prodes-caatinga-nb:yearly_deforestation', description: 'Yearly deforestation biome since 2004' },
        // { name: 'prodes-mata-atlantica-nb:yearly_deforestation', description: 'Yearly deforestation biome since 2004' },
        // { name: 'prodes-cerrado-nb:yearly_deforestation', description: 'Yearly deforestation in the Cerrado Biome' },
        // { name: 'prodes-amazon-nb:yearly_deforestation_biome', description: 'Yearly deforestation biome since 2008' }
    ],
    terrabrasilis_image: (layer: string) => {
        return L.tileLayer.wms(`https://terrabrasilis.dpi.inpe.br/geoserver/wms?typeName=${layer}`, {
            layers: 'biome_border',
            format: 'image/png',
            transparent: true,
            maxZoom: 20,
        })
    },
    terrabrasilis_static: () => {
        return L.tileLayer.wms('https://terrabrasilis.dpi.inpe.br/geoserver/wms', {
            layers: 'biome_border',
            format: 'image/png',
            transparent: true,
            maxZoom: 20,
        })
    },
    // Função INTERATIVA (WFS) - Apenas para a camada que funciona.
    terrabrasilis_interactive: (layerName: string) => {
        const wfsUrl = `https://terrabrasilis.dpi.inpe.br/geoserver/wms?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json`;
        // Criamos uma camada L.geoJSON vazia que será preenchida com os dados do fetch
        const geoJsonLayer = L.geoJSON(undefined, {
            onEachFeature: (feature, layer) => {
                // Pega todas as propriedades do polígono
                const properties = feature.properties;
                let popupContent = `<h4>${layerName}</h4><hr>`;

                // Cria o conteúdo do popup dinamicamente com todas as propriedades
                for (const key in properties) {
                    if (properties.hasOwnProperty(key)) {
                        popupContent += `<strong>${key}:</strong> ${properties[key]}<br>`;
                    }
                }

                layer.bindPopup(popupContent);
            },
            style: {
                color: "#FF5733", // Uma cor diferente para a camada interativa
                weight: 2,
                opacity: 1,
                fillOpacity: 0.4
            }
        });

        fetch(wfsUrl)
            .then(response => response.json())
            .then(data => { geoJsonLayer.addData(data); })
            .catch(error => console.warn(`Camada interativa '${layerName}' não pôde ser carregada.`));

        return geoJsonLayer;
    },
};
export const biomas = mapas.biomas_layers.reduce((acc: any, layer: any) => {
    acc[
        layer.toLowerCase().replaceAll('_', ' ').split(' ').map((word: string) => {
            return word.charAt(0).toUpperCase() + word.substring(1)
        }).join(' ')
    ] = mapas.biomas(layer);
    return acc;
}, {});
// NOVO grupo interativo (WFS) do MapBiomas
// export const biomas_interactive = mapas.biomas_layers.reduce((acc: any, layer: any) => {
//     const formattedName = layer.toLowerCase().replaceAll('_', ' ').split(' ').map((word: string) => {
//         return word.charAt(0).toUpperCase() + word.substring(1)
//     }).join(' ');
//     acc[formattedName] = mapas.biomas_interactive(layer);
//     return acc;
// }, {});
export const terrabrasilis_interactive = mapas.terrabrasilis_wms_layers.reduce((acc: any, layer: any) => {
    // Usamos a nova função que cria camadas GeoJSON
    acc[layer.description] = mapas.terrabrasilis_interactive(layer.name);
    return acc;
}, {});
const groupedOverlays = {
    'Embrapa': {
        'Embrapa': mapas.embrapa()
    },
    'OWS': {
        'Lugares': mapas.ows_places(),
        'Lugares com topografia': mapas.ows_places_topo(),
        'Topografia com Lugares': mapas.ows_topo_places(),
        'Topografia': mapas.ows_topo(),

    },
    'Google': {
        'Google Satélite': mapas.googleSat(),
        'Google Ruas': mapas.googleStreets(),
        'Google Relevo': mapas.googleTerrain(),
        'Google Híbrido': mapas.googleHybrid(),

    },
    'ArcGis': {
        'World Imagery': mapas.arcgis(),
        'Online World Imagery ': mapas.arcgis2(),
        'Online World Boundaries and Places Alternate': mapas.arcgis3()
    },
    // Grupo 2: Camadas do Sentinel
    'Sentinel 2': {
        'True Color': mapas.sentinelTrue(),
        'NDVI': mapas.sentinelNDVI(),
        'NDVI L1C': mapas.sentinelNDVIL1C(),
        'False Color': mapas.sentinelFalse(),
        'False Color L1C': mapas.sentinelFalseL1C(),
        'SWIR': mapas.sentinelSWIR(),
        'NDWI': mapas.sentinelNDWI(),
    },
    'Sentinel 1': {
        'True Color': mapas.sentinel1()
    },
    // Grupo 1: Camadas do MapBiomas
    'MapBiomas': biomas,
    // 'MapBiomas Inter': biomas_interactive,
    'TerraBrasilis': {
        'Bordas dos Biomas': mapas.terrabrasilis_image('biome_border')
    },
    'TerraInterativa': terrabrasilis_interactive
};
const baseMapsObject = {
    'Google': mapas.googleHybrid(), // Usando a camada do seu exemplo
    'ESRI': mapas.esri(),
    'ArcGis': mapas.arcgis(),
    // Adicione aqui todos os outros mapas base que desejar
};
export const basemap = L.control.layers({
    Lugares: mapas.ows_places(),
    Topografia: mapas.ows_topo(),
    'Lugares com topografia': mapas.ows_places_topo(),
    'Topografia com Lugares': mapas.ows_topo_places(),
    'Google Satélite': mapas.googleSat(),
    'Google Ruas': mapas.googleStreets(),
    'Google Relevo': mapas.googleTerrain(),
    'Google Híbrido': mapas.googleHybrid(),
    'ArcGis': mapas.arcgis(),
    'ArcGis Online': mapas.arcgis2(),
    'ESRI': mapas.esri(),
    'Sentinel 2 - True Color': mapas.sentinelTrue(),
    'Sentinel 2 - True Color L1C': mapas.sentinelTrueL1C(),
    'Sentinel 2 - NDVI': mapas.sentinelNDVI(),
    'Sentinel 2 - NDVI L1C': mapas.sentinelNDVIL1C(),
    'Sentinel 2 - False Color': mapas.sentinelFalse(),
    'Sentinel 2 - False Color L1C': mapas.sentinelFalseL1C(),
    'Sentinel 2 - SWIR': mapas.sentinelSWIR(),
    'Sentinel 2 - NDWI': mapas.sentinelNDWI(),
    'Sentinel 1': mapas.sentinel1(),
    // 'Stamen Toner': mapas.stamenToner(),
    // 'NexRad': mapas.nexrad() //serviço de meteorologia
}, {
    ...biomas,
    // 'Biomas': mapas.biomas(),
    'Limites Arcgis': mapas.arcgis3(),
})

export const scale = L.control.scale({
    metric: true,
    imperial: false,
    position: 'topleft',

});
export const getWatermark = (mapa: L.Map | null) => {
    if (mapa) {
        // L.Control.Watermark = L.Control.extend({
        //     onAdd: function () {
        //         var img = L.DomUtil.create('img');

        //         img.src = '../../docs/images/logo.png';
        //         img.style.width = '200px';

        //         return img;
        //     },

        //     onRemove: function () {
        //         // Nothing to do here
        //     }
        // });

        // L.control.watermark = function (opts) {
        //     return new L.Control.Watermark(opts);
        // }

        // L.control.watermark({ position: 'bottomleft' }).addTo(mapa);
        // const image: any = new Image();
        // image.src = "https://example.com/watermark.png";

        // const overlay: any = new ImageOverlay<any>({
        //     position: [0, 0],
        //     image,
        //     zIndex: 100,
        // });

        // mapa.addLayer(overlay);
    }

}
export const createMapOnBahia = (mapRef: MutableRefObject<any>, mapa?: L.TileLayer, zoom?: boolean, layers?: boolean, escala?: boolean) => {
    // Criando instância do mapa pelo Leaflet
    const map = L.map(mapRef.current)
    // Posicionando mapa em posição central da Bahia e com Zoom para visualização integral do estado
    map.setView([-13.356751643055382, -42.06571614326295], 6);
    // Configurando o mapa de satélite híbrido do Google
    if (mapa === undefined) mapas.googleHybrid().addTo(map)
    else mapa.addTo(map)
    //Adicionando zoom
    if (zoom !== undefined && !zoom) map.zoomControl.remove()
    // Configurando escala métrica no canto superior direito
    if (escala === undefined || escala) scale.addTo(map)
    //Adicionando referencias de outros mapas
    if (layers === undefined || layers) basemap.addTo(map)
    // Movendo container de controles do leaflet para frente
    // LUCAS ESTA ALTERAÇÃO DA PROBLEMA NO CADASTRO DE IMOVEL
    // const controlsElement = map.getContainer().querySelector('.leaflet-control-container')
    // if (controlsElement) { map.getContainer().parentNode?.appendChild(controlsElement) }
    return map;
}
export const createMapOnBahia2 = (mapRef: string, mapa?: L.TileLayer, zoom?: boolean, layers?: boolean, escala?: boolean) => {
    // Criando instância do mapa pelo Leaflet
    const map = L.map(mapRef)
    // Posicionando mapa em posição central da Bahia e com Zoom para visualização integral do estado
    map.setView([-13.356751643055382, -42.06571614326295], 6);
    // Configurando o mapa de satélite híbrido do Google
    if (mapa === undefined) mapas.googleHybrid().addTo(map)
    else mapa.addTo(map)
    //Adicionando zoom
    if (zoom !== undefined && !zoom) map.zoomControl.remove()
    // Configurando escala métrica no canto superior direito
    if (escala === undefined || escala) scale.addTo(map)
    //Adicionando referencias de outros mapas
    if (layers === undefined || layers) basemap.addTo(map)

    return map;
}
export const createMap = (mapRef: MutableRefObject<any>, mapa = mapas.googleHybrid(), municipios: Array<any> = [], zoom = true, layers = true, escala = true) => {
    // Criando instância do mapa pelo Leaflet
    const map = L.map(mapRef.current)
    // Posicionando mapa em posição central da Bahia e com Zoom para visualização integral do estado
    // Configurando o mapa de satélite híbrido do Google
    mapa.addTo(map)

    //Adicionando zoom
    if (!zoom) map.zoomControl.remove()
    // Configurando escala métrica no canto superior direito
    if (escala) scale.addTo(map)
    //Adicionando referencias de outros mapas
    if (layers)
        //  basemap.addTo(map)
        L.control.groupedLayers(baseMapsObject, groupedOverlays).addTo(map);

    if (municipios && municipios.length > 0)
        loadMunicipioss(map, municipios)
    else
        map.setView([-13.356751643055382, -42.06571614326295], 6);
    // Movendo container de controles do leaflet para frente
    const controlsElement = map.getContainer().querySelector('.leaflet-control-container')
    if (controlsElement) { map.getContainer().parentNode?.appendChild(controlsElement) }
    return map;
}
export const sideBySide = (map: L.Map, leftMap: L.TileLayer, rightMap: L.TileLayer) => {
    leftMap.addTo(map)
    rightMap.addTo(map)
    return L.control.sideBySide(leftMap, rightMap).addTo(map);

}
export const changeSideMap = (control: any, leftMap: L.TileLayer, rightMap: L.TileLayer) => {
    control.setLeftLayers(leftMap);
    control.setRightLayers(rightMap);
}
// export const styledByWithIn = (mapa: L.Map | null, poligonVazio: any, e: any) => {
//     e.preventDefault()
//     // mapa.pm.setGlobalOptions({ pmIgnore: false });
//     if (mapa)
//         if (e.layer && e.layer.pm) {
//             const poligono = e.layer;
//             poligono.pm.enable();

//             // editableLayers.addLayer(poligono)
//             console.log(`object created: ${poligono.pm.getShape()}`);

//             mapa.pm.getGeomanLayers(true)
//             // console.log('Geoman Layers:', mapa.pm.getGeomanLayers())
//             if (mapa.pm.getGeomanLayers) {
//                 const layers: Array<L.Layer> | L.FeatureGroup = mapa.pm.getGeomanLayers()
//                 if (layers instanceof Array) {
//                     const last = layers[layers.length - 1]
//                     const index = layers.length === 0 ? 1 : layers.length - 1
//                     last.bindPopup(`Área ${index} com ${areaInHaOf(last)}`)
//                     last.openPopup()
//                     const poligonoIn = (last as L.Polygon).toGeoJSON()
//                     console.log(poligonVazio)
//                     if (poligonVazio) {
//                         const poligonoOut = (poligonVazio.getLayers()[0] as L.Polygon).toGeoJSON()
//                         const dentro = turf.booleanWithin(poligonoIn, poligonoOut)
//                         console.log('Dentro:', dentro)
//                         if (dentro)
//                             (last as L.Polygon).setStyle({ color: 'cyan' })
//                         else
//                             (last as L.Polygon).setStyle({ color: 'red' })
//                     }
//                 }
//             }
//             poligono.on("pm:edit", (e: any) => {
//                 console.log("object edited: ", e);
//             });
//         }
// }

// export const addControl = (mapa: L.Map | null ) => {
//     const Control = L.Control.extend({
//         onAdd: function(map: any) {
//           var el = L.DomUtil.create('div', 'leaflet-bar my-control');

//           el.innerHTML = 'My Control';

//           return el;
//         },

//         onRemove: function(map: any) {
//           // Nothing to do here
//         }
//       });

//       const control = function(opts: any) {
//         return Control(opts);
//       }

//       L.control.myControl({
//         position: 'topright'
//       }).addTo(mapa);
// }

export const saveKML = (mapa: any) => {
    if (mapa) {
        circleToPolygon(mapa)
        var kmlData = '<?xml version="1.0" encoding="UTF-8"?>' +
            '<kml xmlns="http://www.opengis.net/kml/2.2">'
        console.log('asd')
        mapa.eachLayer((poligono: any) => {
            console.log('asd')
            if (poligono instanceof L.Polygon) {
                kmlData += '<Placemark><name>Polígono</name><Polygon><outerBoundaryIs><LinearRing><coordinates>';
                poligono.getLatLngs().forEach((latlng: any) => {
                    console.log('Latlon', latlng)
                    latlng.forEach((coord: any, index: number) => {
                        kmlData += coord.lng + ',' + coord.lat + ',0 ';
                    })
                });

                kmlData += '</coordinates></LinearRing></outerBoundaryIs></Polygon></Placemark></kml>';


            }
        });
        // Criar um blob com os dados KML
        var blob = new Blob([kmlData], { type: 'application/vnd.google-earth.kml+xml' });

        // Criar um link para download do arquivo KML
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'poligono.kml';

        // Adicionar o link ao documento e clicá-lo automaticamente para iniciar o download
        document.body.appendChild(link);
        link.click();

        // Remover o link do documento
        document.body.removeChild(link);
    }
}

const defaultMapControls: L.PM.ToolbarOptions = {
    position: "bottomright",
    drawMarker: false,
    drawCircleMarker: false,
    drawPolygon: true,
    drawCircle: true,
    drawPolyline: false,
    drawRectangle: true,
    rotateMode: false,
    drawText: false,
}

export const editableMap = (mapa: L.Map | null, back?: Function, buttons?: Array<ButtonMap>, polygon?: any, setPoligono?: Function, onePolygon?: boolean, buttonOptions?: L.PM.ToolbarOptions, setRemovePolygon?: Function) => {
    if (mapa) {

        // const editableLayers = new L.FeatureGroup();
        // mapa.addLayer(editableLayers);

        mapa.pm.addControls(buttonOptions || defaultMapControls);

        var customControl = L.Control.extend({
            options: {
                position: 'bottomright'
            },

            onAdd: function (map: any) {
                var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

                var input = L.DomUtil.create('input', '', container);
                input.type = 'file';
                input.style.display = 'none';
                input.onchange = function (e: any) {
                    openFile(e, mapa)
                };

                const contentButtons = [
                    {
                        icon: '<img width="18" src="https://www.svgrepo.com/show/376086/import.svg">',
                        func: function () { input.click() }
                    },
                    {
                        icon: '<img width="16" src="https://www.svgrepo.com/show/449207/save-filled.svg">',
                        func: function () { salvarShapefile(mapa) }
                    },
                    {
                        icon: '<img width="22" src="https://www.svgrepo.com/show/158088/kml-file-format-interface.svg">',
                        func: function () { saveKML(mapa) }
                    },
                    {
                        icon: '<img width="18" src="https://www.svgrepo.com/show/51246/home-map-location.svg">',
                        func: function () { goHome(mapa) }
                    }
                ]

                contentButtons.map((content) => {
                    var button: HTMLButtonElement = L.DomUtil.create('button', '', container)
                    button.innerHTML = content.icon
                    button.onclick = content.func
                    button.style.width = '32px'
                    button.style.height = '32px'
                    button.style.display = 'flex'
                    button.style.alignItems = 'center'
                    button.style.justifyContent = 'center'
                })

                L.DomEvent.disableClickPropagation(container);

                return container;
            }
        });

        // if (loadButtons)
        mapa.addControl(new customControl());

        if (back) {
            var backControl = L.Control.extend({
                options: {
                    position: 'topleft'
                },

                onAdd: function (map: any) {
                    var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

                    var input = L.DomUtil.create('input', '', container);
                    input.type = 'file';
                    input.style.display = 'none';
                    input.onchange = function (e: any) {
                        openFile(e, mapa)
                    };


                    var button: HTMLButtonElement = L.DomUtil.create('button', '', container)
                    button.innerHTML = '<img width="22" src="https://www.svgrepo.com/show/500472/back.svg">'
                    button.onclick = function () { back() }
                    button.style.width = '32px'
                    button.style.height = '32px'
                    button.style.display = 'flex'
                    button.style.alignItems = 'center'
                    button.style.justifyContent = 'center'


                    L.DomEvent.disableClickPropagation(container);

                    return container;
                }
            });

            mapa.addControl(new backControl());
        }

        if (buttons) {
            var customControl2 = L.Control.extend({
                options: {
                    position: 'topright'
                },

                onAdd: function (map: any) {
                    var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

                    var input = L.DomUtil.create('input', 'hidden', container);
                    input.type = 'file';
                    input.onchange = function (e: any) {
                        openFile(e, mapa)
                    };

                    buttons.map((content) => {
                        var button: HTMLButtonElement = L.DomUtil.create('button', '', container)
                        button.innerHTML = content.icon
                        button.onclick = function () { content.func() }
                        button.style.width = '32px'
                        button.style.height = '32px'
                        button.style.display = 'flex'
                        button.style.alignItems = 'center'
                        button.style.justifyContent = 'center'
                    })

                    L.DomEvent.disableClickPropagation(container);

                    return container;
                }
            });

            mapa.addControl(new customControl2());
        }
        // var div = document.createElement('div');
        // div.innerHTML = '<ConfirmPopup />';

        // mapa.getContainer().appendChild(div)
        // mapa.pm.setPathOptions({
        // color: 'blue',
        // fillColor: 'blue',
        // fillOpacity: 0.2,
        // });

        // mapa.pm.setGlobalOptions({ pmIgnore: false });
        mapa.on('pm:create', (e: any) => {
            // mapa.on(L.Draw.Event.CREATED, (e: any) => {
            if (e.layer && e.layer.pm) {
                const poligono: L.Polygon = e.layer;
                poligono.pm.enable();

                if (setPoligono)
                    setPoligono(poligono)

                // editableLayers.addLayer(poligono)

                // mapa.pm.getGeomanLayers(true)
                // console.log('Geoman Layers:', mapa.pm.getGeomanLayers())
                if (mapa.pm.getGeomanLayers) {
                    const layers: Array<L.Layer> | FeatureGroup = mapa.pm.getGeomanLayers()
                    if (layers instanceof Array) {
                        const last = layers[layers.length - 1]
                        const index = layers.length === 0 ? 1 : layers.length - 1
                        last.bindPopup(`Área ${index} com ${areaInHaOf(last)}`)
                        last.openPopup()
                    }
                }
                poligono.on('pm:edit', (e) => {
                    if (setPoligono) {
                        setPoligono(null)
                        setTimeout(() => setPoligono(e.layer), 100)
                    }
                })
                // poligono.on("pm:edit", (e: any) => {
                // poligono.on(L.Draw.Event.EDITED, (e: any) => {
                //     console.log("object edited: ", e);
                // });
            }
        })

        mapa.on("pm:remove", (e: any) => {
            setRemovePolygon && setRemovePolygon(e.layer)
        });

        // leafletContainer.on("pm:edit", (e: any) => {
        //   console.log("object edited");
        //   console.log(e);

        // });

        // return () => {
        //     mapa.pm.removeControls();
        //     // mapa.pm.setGlobalOptions({ pmIgnore: true });
        // };
        // return editableLayers;
    }
    // return null;
}

// Definições de tipo para clareza
interface ProcessGeojsonParams {
    startDate: string; // Formato "YYYY-MM-DD"
    endDate: string;   // Formato "YYYY-MM-DD"
    geojsonBody: any;  // Seu objeto GeoJSON
    timeoutMs?: number; // Timeout em milissegundos (opcional)
}

interface ProcessGeojsonResult {
    success: boolean;
    data?: Blob;       // O blob do PDF se sucesso
    fileName?: string;   // Nome do arquivo do PDF, extraído do Content-Disposition
    error?: string;      // Mensagem de erro se falha
    statusCode?: number; // Código de status HTTP da resposta
}

/**
 * Extrai o nome do arquivo do header Content-Disposition.
 * Lida com formatos como:
 * filename="nome.pdf"
 * filename*=UTF-8''nome%20com%20espa%C3%A7os.pdf
 */
function getFileNameFromContentDisposition(contentDisposition: string | null): string {
    let fileName = 'relatorio_processado.pdf'; // Nome padrão
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']+)['"]?/i);
        if (fileNameMatch && fileNameMatch[1]) {
            try {
                fileName = decodeURIComponent(fileNameMatch[1]);
            } catch (e) {
                // Fallback se decodeURIComponent falhar
                fileName = fileNameMatch[1];
            }
        }
    }
    return fileName;
}


/**
     * Função para requisitar o processamento do GeoJSON ao backend.
     * @param params Parâmetros da requisição, incluindo datas, GeoJSON e timeout opcional.
     * @returns Uma promessa que resolve para um objeto ProcessGeojsonResult.
     */
async function requestProcessGeojson(params: ProcessGeojsonParams): Promise<ProcessGeojsonResult> {
    const { startDate, endDate, geojsonBody, timeoutMs = 300000 } = params; // Timeout padrão de 5 minutos (300000 ms)

    const baseUrl = "https://api.monitorabahia.gearspark.com.br/api/process-geojson/";
    const url = new URL(baseUrl);
    url.searchParams.append('start', startDate);
    url.searchParams.append('end', endDate);

    const controller = new AbortController();
    const signal = controller.signal;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (timeoutMs > 0) {
        timeoutId = setTimeout(() => {
            console.warn(`Requisição para ${url.toString()} abortada por timeout de ${timeoutMs}ms.`);
            controller.abort();
        }, timeoutMs);
    }

    try {
        console.log(`Enviando POST para: ${url.toString()}`);
        const response = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Adicione aqui outros cabeçalhos necessários, como Authorization, se houver.
            },
            body: JSON.stringify(geojsonBody), // Envie o GeoJSON diretamente como corpo
            signal, // Permite o abort da requisição
        });

        if (timeoutId) {
            clearTimeout(timeoutId); // Limpa o timeout se a requisição completar ou falhar antes
        }

        const contentType = response.headers.get('Content-Type');
        const contentDisposition = response.headers.get('Content-Disposition');

        if (response.ok) {
            if (contentType && contentType.includes('application/pdf')) {
                const blob = await response.blob();
                const fileName = getFileNameFromContentDisposition(contentDisposition);
                console.log(`PDF recebido: ${fileName}, tamanho: ${blob.size} bytes`);
                return {
                    success: true,
                    data: blob,
                    fileName: fileName,
                    statusCode: response.status,
                };
            } else {
                // Resposta OK, mas não é PDF - pode ser um JSON inesperado de sucesso
                const responseText = await response.text();
                console.warn("Resposta OK, mas não é PDF:", responseText);
                return {
                    success: false, // Considerar como falha se um PDF era esperado
                    error: `Resposta inesperada do servidor (esperava PDF): ${responseText.substring(0, 100)}...`,
                    statusCode: response.status,
                };
            }
        } else {
            // Tratar erros HTTP (4xx, 5xx)
            let errorMessage = `Erro ${response.status}: ${response.statusText}`;
            if (contentType && contentType.includes('application/json')) {
                try {
                    const errorJson = await response.json();
                    errorMessage = errorJson.detail || JSON.stringify(errorJson);
                } catch (e) {
                    // Se não conseguir parsear o JSON de erro, usa o texto da resposta
                    errorMessage = await response.text();
                }
            } else {
                errorMessage = await response.text();
            }
            console.error(`Erro na requisição: Status ${response.status}, Mensagem: ${errorMessage}`);
            return {
                success: false,
                error: errorMessage,
                statusCode: response.status,
            };
        }
    } catch (error: any) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        if (error.name === 'AbortError') {
            console.error('A requisição foi abortada devido ao timeout.');
            return { success: false, error: `A requisição excedeu o tempo limite de ${timeoutMs / 1000} segundos.`, statusCode: 408 };
        }
        console.error('Erro na requisição fetch:', error);
        return { success: false, error: `Erro de rede ou na requisição: ${error.message}` };
    }
}


/**
 * Lida com o clique do botão de processamento no popup de uma feature.
 * @param feature O objeto GeoJSON da feature a ser processada.
 * @param layer A camada Leaflet associada à feature (para atualizar o popup).
 * @param startDateStr Data de início para o processamento (formato "YYYY-MM-DD").
 * @param endDateStr Data de fim para o processamento (formato "YYYY-MM-DD").
 */
async function handleProcessFeatureClick(
    feature: any, // Ou 'any' se você não tipar estritamente o GeoJSON
    layer: L.Layer,
    startDateStr: string,
    endDateStr: string
) {
    if (!feature || !feature.geometry) {
        console.error("Feature ou geometria inválida para processamento.");
        alert("Erro: Geometria inválida para processamento.");
        return;
    }

    // Pegar o popup da camada para atualizar o feedback
    const popup = layer.getPopup();
    let originalPopupContent = "";
    if (popup) {
        originalPopupContent = popup.getContent() as string;
        // Remove o botão para evitar cliques múltiplos e adiciona mensagem de processamento
        const buttonRegex = /<button id="[^"]+">Processar este CAR<\/button>/;
        const contentWithoutButton = originalPopupContent.replace(buttonRegex, "");
        popup.setContent(contentWithoutButton + "<br><i>Processando... Por favor, aguarde.</i>");
    } else {
        console.warn("Popup não encontrado para a camada.");
    }

    console.log(`Processando CAR: ${feature.properties?.cod_imovel || feature.id || 'ID Desconhecido'}`);

    // O geojsonBody para requestProcessGeojson deve ser um objeto GeoJSON válido.
    // Uma Feature GeoJSON já é um objeto GeoJSON válido.
    const params: ProcessGeojsonParams = {
        startDate: startDateStr,
        endDate: endDateStr,
        geojsonBody: feature, // Passa a feature GeoJSON inteira
        timeoutMs: 300000, // 5 minutos de timeout (ajuste se necessário)
    };

    try {
        const result = await requestProcessGeojson(params); // Sua função de API existente

        let resultMessage = "";
        if (result.success && result.data && result.fileName) {
            const downloadUrl = window.URL.createObjectURL(result.data);
            // Cria um link para download no popup
            resultMessage = `<br><b>Sucesso!</b> <a href="${downloadUrl}" download="${result.fileName}" target="_blank" rel="noopener noreferrer">Baixar ${result.fileName}</a>`;

            // Opcional: disparar o download automaticamente (pode ser bloqueado por pop-up blockers)
            // const link = document.createElement('a');
            // link.href = downloadUrl;
            // link.setAttribute('download', result.fileName);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(downloadUrl); // Revogar após um tempo se o download for automático

            console.log(`Download do arquivo ${result.fileName} disponível no popup.`);
        } else {
            resultMessage = `<br><b>Falha:</b> ${result.error || 'Erro desconhecido'} (Status: ${result.statusCode || 'N/A'})`;
            console.error("Falha ao processar ou obter PDF:", result.error, "Status:", result.statusCode);
        }

        if (popup) {
            // Remove o "Processando..." e o botão original, adiciona a mensagem de resultado
            const buttonAndSpinnerRegex = /<button id="[^"]+">Processar este CAR<\/button><br><i>Processando\.\.\. Por favor, aguarde\.<\/i>/;
            const contentWithoutButtonAndSpinner = originalPopupContent.replace(buttonAndSpinnerRegex, "");
            popup.setContent(contentWithoutButtonAndSpinner + resultMessage);
        }

    } catch (e: any) {
        console.error("Erro inesperado ao chamar requestProcessGeojson do popup:", e);
        if (popup) {
            const buttonAndSpinnerRegex = /<button id="[^"]+">Processar este CAR<\/button><br><i>Processando\.\.\. Por favor, aguarde\.<\/i>/;
            const contentWithoutButtonAndSpinner = originalPopupContent.replace(buttonAndSpinnerRegex, "");
            popup.setContent(contentWithoutButtonAndSpinner + `<br><b>Erro catastrófico:</b> ${e.message || 'Erro desconhecido'}`);
        }
    }
}

export const getCars = async (municipio: string, uf = 'BA') => {
    let allFeatures: any[] = [];
    let startIndex = 0;
    const featuresPerPage = 1000; // O servidor parece limitar a 1000 por página
    let totalFeaturesMatched = 0;
    let continueFetching = true;
    let cqlFilter = `cod_municipio_ibge='${municipio}'`;

    // Limpar camadas anteriores de CAR, se houver (opcional, depende da sua lógica)
    // Ex: if (carLayerGlobal) mapa.removeLayer(carLayerGlobal);

    console.log(`Iniciando busca paginada para o município IBGE: ${municipio}`);

    while (continueFetching) {
        const wfsUrl = `https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_${uf.toLowerCase()}&outputFormat=application%2Fjson&CQL_FILTER=${encodeURIComponent(cqlFilter)}&MAXFEATURES=${featuresPerPage}&STARTINDEX=${startIndex}`;

        console.log(`Buscando: ${wfsUrl}`);

        try {
            const response = await fetch(wfsUrl);
            if (!response.ok) {
                throw new Error(`Erro na requisição da página: ${response.status} ${response.statusText}`);
            }
            const geojsonPage = await response.json();

            if (startIndex === 0) { // Na primeira requisição
                totalFeaturesMatched = geojsonPage.totalFeatures || geojsonPage.numberMatched || 0;
                console.log(`Total de imóveis CAR para o município: ${totalFeaturesMatched}`);
                if (totalFeaturesMatched === 0) {
                    alert(`Nenhuma feição encontrada para o município com código IBGE: ${municipio}`);
                    continueFetching = false;
                    break;
                }
            }

            if (geojsonPage.features && geojsonPage.features.length > 0) {
                allFeatures = allFeatures.concat(geojsonPage.features);
                console.log(`Recebidas ${geojsonPage.features.length} feições. Total acumulado: ${allFeatures.length} de ${totalFeaturesMatched}`);

                startIndex += geojsonPage.features.length; // ou geojsonPage.numberReturned

                // Condição de parada:
                // 1. Se o número de feições buscadas já é o total de feições do município.
                // 2. Se a última página retornou menos feições que o solicitado por página (indicando que é a última página).
                // 3. Se startIndex for maior ou igual ao total de feições (caso de segurança).
                if (allFeatures.length >= totalFeaturesMatched || geojsonPage.features.length < featuresPerPage || startIndex >= totalFeaturesMatched) {
                    continueFetching = false;
                }
            } else {
                console.log("Nenhuma feição retornada nesta página, parando.");
                continueFetching = false; // Nenhuma feição retornada, fim da paginação
            }

            // Adicionar uma pequena pausa para não sobrecarregar o servidor, se continuar buscando
            if (continueFetching) {
                await new Promise(resolve => setTimeout(resolve, 1)); // Pausa de 250ms
            }

        } catch (error: any) {
            console.error(`Erro ao buscar página com startIndex ${startIndex}:`, error);
            alert(`Erro ao buscar dados: ${error.message}. Verifique o console.`);
            continueFetching = false; // Para o loop em caso de erro
            // Você pode decidir retornar as feições parciais ou um erro
            return { features: allFeatures, totalFetched: allFeatures.length, totalMatchedServer: totalFeaturesMatched, error: error.message };
        }
    }

    console.log(`Busca finalizada. Total de ${allFeatures.length} feições CAR carregadas para o município ${municipio}.`);

    if (allFeatures.length > 0) {
        if (allFeatures.length < totalFeaturesMatched) {
            alert(`Atenção: Foram carregadas ${allFeatures.length} de ${totalFeaturesMatched} feições. Pode ter ocorrido um problema na paginação ou limite inesperado do servidor.`);
        }

        const geojsonCompleto: any = {
            type: "FeatureCollection",
            totalFeatures: allFeatures.length, // Ou totalFeaturesMatched se confiar no primeiro retorno
            numberMatched: allFeatures.length,
            numberReturned: allFeatures.length,
            features: allFeatures
            // Adicione o CRS se souber/necessário, ex: crs: geojsonPage.crs (do último fetch)
        };
        return geojsonCompleto; // Retorna o GeoJSON completo
    } else if (totalFeaturesMatched > 0) { // Se o total era > 0 mas nada foi carregado
        alert(`Nenhuma feição foi efetivamente carregada para o município ${municipio}, embora o servidor tenha indicado ${totalFeaturesMatched} feições.`);
    }

    return allFeatures; // Retorna todas as feições carregadas
}
export const getCarsEmParalelo = async (municipio: string, uf = 'BA') => {
    const featuresPerPage = 1000;
    const cqlFilter = `cod_municipio_ibge='${municipio}'`;

    const discoveryUrl = `https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_${uf.toLowerCase()}&outputFormat=application%2Fjson&CQL_FILTER=${encodeURIComponent(cqlFilter)}&MAXFEATURES=1`;

    // console.log(`Buscando total de feições (discovery): ${discoveryUrl}`);

    let totalFeatures = 0;
    try {
        const response = await fetch(discoveryUrl);
        if (!response.ok) {
            const errorBody = await response.text();
            throw new Error(`Erro na requisição de descoberta: ${response.status} ${response.statusText}. Corpo: ${errorBody}`);
        }

        // --- LÓGICA CORRIGIDA ---
        // 1. Lemos o corpo da resposta como TEXTO uma única vez.
        const responseText = await response.text();

        let discoveryData;
        try {
            // 2. TENTAMOS analisar a variável de texto como JSON.
            discoveryData = JSON.parse(responseText);
        } catch (jsonError) {
            // 3. Se falhar, sabemos que não era JSON. Logamos o texto original (que provavelmente é o XML de erro).
            console.error("Falha ao analisar a resposta como JSON. A resposta do servidor provavelmente é um XML de erro.");
            console.error("Conteúdo da resposta do servidor:", responseText);
            throw new Error("A resposta do servidor não era um JSON válido.");
        }
        // --- FIM DA LÓGICA CORRIGIDA ---

        totalFeatures = discoveryData.totalFeatures || discoveryData.numberMatched || 0;

        // console.log(`Total de imóveis CAR encontrados: ${totalFeatures}`);
        if (totalFeatures === 0) {
            // alert(`Nenhuma feição encontrada para o município com código IBGE: ${municipio}`);
            return { type: "FeatureCollection", features: [] } as const;
        }
    } catch (error: any) {
        console.error("Erro ao obter a contagem total de feições:", error);
        alert(`Não foi possível obter a contagem de imóveis para o município. Erro: ${error.message}`);
        return null;
    }

    // O resto da função continua o mesmo...
    const pageRequests = [];
    for (let startIndex = 0; startIndex < totalFeatures; startIndex += featuresPerPage) {
        const wfsUrl = `https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_${uf.toLowerCase()}&outputFormat=application%2Fjson&CQL_FILTER=${encodeURIComponent(cqlFilter)}&MAXFEATURES=${featuresPerPage}&STARTINDEX=${startIndex}`;

        pageRequests.push(fetch(wfsUrl).then(res => {
            if (!res.ok) {
                throw new Error(`Falha ao buscar página com startIndex ${startIndex}`);
            }
            return res.json();
        }));
    }

    // console.log(`Disparando ${pageRequests.length} requisições em paralelo...`);

    try {
        const allPages = await Promise.all(pageRequests);
        const allFeatures = allPages.flatMap(page => page.features || []);

        // console.log(`Busca paralela finalizada. Total de ${allFeatures.length} de ${totalFeatures} feições carregadas.`);

        if (allFeatures.length < totalFeatures) {
            alert(`Atenção: Foram carregadas ${allFeatures.length} de ${totalFeatures} feições. Pode ter ocorrido um problema na busca paralela.`);
        }
        // console.log('CARS', allFeatures)
        return {
            type: "FeatureCollection",
            totalFeatures: allFeatures.length,
            features: allFeatures
        } as const;

    } catch (error: any) {
        console.error("Erro durante a busca paralela das feições:", error);
        alert(`Ocorreu um erro ao carregar todos os dados do CAR. Verifique o console. Detalhes: ${error.message}`);
        return null;
    }
}
export const loadMunicipioCars = async (mapa: L.Map | null, municipio: any, estilo = estiloArea, flyTo = true, car = false, navigate: any, selectCar: Function, setCar: Function, setCars: Function) => {
    var all: AllType = { municipio: null, cars: [] }
    if (mapa) {
        try {
            const response = await fetch(IBGE_URL + 'municipios/' + municipio.id + '?formato=application/vnd.geo+json')
            const data = await response.json()
            //console.log('Mapa Data Json: ', data)
            const poligono: L.GeoJSON | any = L.geoJSON(data)
            poligono.bindPopup(popUpForMunicipio(municipio, poligono))
            poligono.setStyle(estilo)
            mapa?.addLayer(poligono)

            if (flyTo)
                mapa.flyToBounds(poligono.getBounds())
            all = { ...all, municipio: poligono }

            if (car)
                try {
                    const cars = await getCarsEmParalelo(municipio.id, global.uf)
                    // console.log('Cars Json: ', cars)
                    if (cars) {
                        const geojson = L.geoJSON(cars, {
                            style: estiloArea,
                            onEachFeature: function (feature, layer) {
                                // console.log('Feature:', feature.properties);
                                if (feature.properties) {
                                    // Conteúdo inicial do popup
                                    const car = feature.properties;
                                    const codigo = car.cod_imovel.replace(car.uf + '-' + car.cod_municipio_ibge + '-', '').toUpperCase()

                                    layer.on('click', () => {
                                        selectCar(layer, geojson.getLayers());
                                        setCar(layer);
                                    })

                                    let popupHtmlContent =
                                        '<h1>Imóvel CAR</h1><hr>' +
                                        `<b>Código: ${codigo || 'N/A'}<br>` +
                                        `Unidade Federativa: ${car.uf || 'N/A'}<br>` +
                                        `Município: ${car.municipio || 'N/A'} (${car.cod_municipio_ibge || 'N/A'})<br>` +
                                        `Área (ha): ${car.area ? car.area.toFixed(2) : 'N/A'}<br>` +
                                        `Condição: ${car.condicao || 'N/A'}<br>` +
                                        `Data de criação: ${car.dat_criacao ? new Date(car.dat_criacao).toLocaleDateString() : 'N/A'}<br>` +
                                        `Data de atualização: ${car.data_atualizacao ? new Date(car.data_atualizacao).toLocaleDateString() : 'N/A'}<br>` +
                                        `Status do imóvel: ${car.status_imovel || 'N/A'}<br>` +
                                        `Tipo de imóvel: ${car.tipo_imovel || 'N/A'}<br>` +
                                        `Módulo fiscal: ${car.m_fiscal ? car.m_fiscal.toFixed(2) : 'N/A'}<br>`

                                    layer.bindPopup(popupHtmlContent);
                                    all.cars.push({ poligono: layer as L.GeoJSON, codigo: codigo });
                                }


                            }
                        }).addTo(mapa);
                    } else {
                        console.log("Não foi possível carregar os dados dos CARs, a variável retornou nula.");
                    }

                    // cars.map(async (c: any) => {
                    //     const poligonos = await carregarZipFromURLDBF(c.car, estiloArea)
                    //     poligonos.eachLayer(poligono => {
                    //         // poligono.bindPopup(popUpForCar(c, poligono))
                    //         // poligono.on('click', () => {selectCar(poligono, poligonoss)})
                    //         mapa.addLayer(poligono)
                    //         all.cars.push(poligono as L.GeoJSON)
                    //     })
                    //     all.cars.forEach((c) => {
                    //         c.on('click', () => {
                    //             selectCar(c, all.cars)
                    //             setCar(c)
                    //         })
                    //     })
                    // })
                    setCars(all.cars)

                } catch (e: any) {
                    console.log('Erro no carregamento do CAR do municipio ' + municipio.nome, municipio)
                    console.log('Descrição do erro', e)
                }
        } catch (e: any) {
            console.log('Erro no carregamento do municipio ' + municipio.nome, municipio)
            console.log('Descrição do erro', e)
        }
    }
    return all
}

export const drawCarsProcessingPopups = async (mapa: L.Map, municipio: string, uf = 'BA') => {
    const geojsonCompleto = await getCars(municipio, uf);
    if (geojsonCompleto) {
        // Dentro da parte L.geoJSON:
        const geojson = L.geoJSON(geojsonCompleto, {
            style: function (feature) {
                return { color: 'green', weight: 1, fillColor: 'green', fillOpacity: 0.1 };
            },
            onEachFeature: function (feature, layer) {
                // Conteúdo inicial do popup
                let popupHtmlContent = "<b>Imóvel CAR</b><br>";
                if (feature.properties) {
                    popupHtmlContent += `Município: ${feature.properties.municipio || 'N/A'} (${feature.properties.cod_municipio_ibge || 'N/A'})<br>`;
                    popupHtmlContent += `Código: ${feature.properties.cod_imovel || 'N/A'}<br>`;
                    popupHtmlContent += `Área (ha): ${feature.properties.area ? feature.properties.area.toFixed(2) : 'N/A'}<br>`;
                    popupHtmlContent += `Condição: ${feature.properties.condicao || 'N/A'}<br>`;
                }

                // Gerar um ID único para o botão para cada feature
                const uniqueButtonId = `process-car-btn-${feature.id || feature.properties?.cod_imovel || Math.random().toString(36).substring(2, 9)}`;
                popupHtmlContent += `<button id="${uniqueButtonId}">Processar este CAR</button>`;

                const currentPopup = layer.bindPopup(popupHtmlContent);

                // Adicionar o event listener quando o popup é aberto
                currentPopup.on('popupopen', () => {
                    const processButton = document.getElementById(uniqueButtonId);
                    if (processButton) {
                        // Remove listener antigo para evitar múltiplos anexos se o popup for reaberto
                        const newProcessButton = processButton.cloneNode(true) as HTMLElement;
                        processButton.parentNode?.replaceChild(newProcessButton, processButton);

                        newProcessButton.onclick = () => {
                            // --- ATENÇÃO: Defina suas datas de início e fim aqui ---
                            // Elas podem vir de um estado do React, de inputs na UI,
                            // ou serem as mesmas usadas para a consulta inicial.
                            // Exemplo, se você tiver inputs para o usuário definir:
                            // const startDate = (document.getElementById('your-start-date-input-id') as HTMLInputElement)?.value || 'YYYY-MM-DD';
                            // const endDate = (document.getElementById('your-end-date-input-id') as HTMLInputElement)?.value || 'YYYY-MM-DD';

                            // Por agora, vou usar as mesmas datas que você usou no exemplo do botão principal:
                            const startDateForProcessing = '2024-08-01';
                            const endDateForProcessing = '2024-08-31';

                            // Validar as datas aqui se necessário antes de chamar
                            if (!startDateForProcessing || !endDateForProcessing) {
                                alert("Por favor, defina as datas de início e fim para o processamento.");
                                return;
                            }

                            handleProcessFeatureClick(feature, layer, startDateForProcessing, endDateForProcessing);
                        };
                    }
                });
            }
        }).addTo(mapa);


        // Opcional: Ajustar o zoom do mapa para a camada carregada
        // if (mapa.hasLayer(carLayerGlobal)) {
        //     mapa.fitBounds(carLayerGlobal.getBounds());
        // }
        return geojson; // Retorna a camada GeoJSON para uso posterior, se necessário
    }


    // Retornar os dados consolidados (opcional, para uso posterior se necessário)
    // return { features: allFeatures, totalFetched: allFeatures.length, totalMatchedServer: totalFeaturesMatched, error: null };
    return null;
}
export const getCarsPNG = (mapa: L.Map,) => {
    // Adicionar a camada do CAR da Bahia via WMS
    const carWMSLayer = L.tileLayer.wms('https://geoserver.car.gov.br/geoserver/sicar/ows', {
        layers: 'sicar:sicar_imoveis_ba', // Nome da camada WMS
        format: 'image/png',             // Formato da imagem
        transparent: true,               // Para que o fundo do tile seja transparente
        version: '1.1.0',                // Ou '1.3.0' - verifique qual funciona melhor
        attribution: "CAR - SICAR / MMA" // Atribuição da fonte dos dados
    }).addTo(mapa);

    console.log('Camada WMS do CAR da Bahia adicionada ao mapa.');
}
export const addButton = (mapa: L.Map, func: Function, position: string, icon: string) => {
    var backControl = L.Control.extend({
        options: {
            position: position
        },

        onAdd: function (map: any) {
            var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

            var input = L.DomUtil.create('input', '', container);
            input.type = 'file';
            input.style.display = 'none';
            input.onchange = function (e: any) {
                openFile(e, mapa)
            };


            var button: HTMLButtonElement = L.DomUtil.create('button', '', container)
            button.innerHTML = '<img width="22" src="' + icon + '">'
            button.onclick = function () { func() }
            button.style.width = '32px'
            button.style.height = '32px'
            button.style.display = 'flex'
            button.style.alignItems = 'center'
            button.style.justifyContent = 'center'


            L.DomEvent.disableClickPropagation(container);

            return container;
        }
    });

    mapa.addControl(new backControl());
}
export const loadCar = async (mapa: L.Map, codigoMunicipioIBGE: string, maxFeaturesSolicitadas = 50000) => {
    const cars: Array<L.GeoJSON> = []
    // Construir a URL do WFS com o filtro CQL e MAXFEATURES
    const carWfsUrl = `https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_ba&outputFormat=application%2Fjson&CQL_FILTER=cod_municipio_ibge='${codigoMunicipioIBGE}'&MAXFEATURES=${maxFeaturesSolicitadas}`
    // URL do GeoJSON do CAR para a Bahia
    // const carWfsUrl = 'https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_ba&outputFormat=application%2Fjson';
    // const carWfsUrl = 'https://geoserver.car.gov.br/geoserver/sicar/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sicar%3Asicar_imoveis_ba&outputFormat=application%2Fjson&CQL_FILTER=municipio=%27Correntina%27'
    // Buscar os dados GeoJSON e adicionar ao mapa
    // Buscar os dados GeoJSON e adicionar ao mapa
    await fetch(carWfsUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
            }
            return response.json();
        })
        .then(geojson => {
            if (geojson.features && geojson.features.length > 0) {
                console.log(`Recebidas ${geojson.numberReturned} feições de um total de ${geojson.totalFeatures} correspondentes para o município.`);

                if (geojson.numberReturned < geojson.totalFeatures) {
                    alert(`Atenção: O servidor retornou ${geojson.numberReturned} feições, mas o município possui ${geojson.totalFeatures} imóveis. Pode haver um limite no servidor que impede o carregamento de todos os dados de uma vez.`);
                }
                if (geojson.numberReturned >= maxFeaturesSolicitadas) {
                    alert(`Atenção: O número de feições retornadas (${geojson.numberReturned}) atingiu o máximo solicitado (${maxFeaturesSolicitadas}). O município pode ter mais imóveis que o valor de MAXFEATURES definido.`);
                }

                const car = L.geoJSON(geojson, {
                    style: function (feature) {
                        // Exemplo de estilo: polígonos laranja com borda fina
                        return { color: 'orange', weight: 1, fillColor: 'orange', fillOpacity: 0.2 };
                    },
                    onEachFeature: function (feature, layer) {
                        // Adicionar um popup com informações do imóvel
                        if (feature.properties) {
                            let popupContent = "<b>Imóvel CAR</b><br>";
                            if (feature.properties.cod_imovel) {
                                popupContent += `Código: ${feature.properties.cod_imovel}<br>`;
                            }
                            if (feature.properties.municipio) {
                                popupContent += `Município: ${feature.properties.municipio}<br>`;
                            }
                            if (feature.properties.area) {
                                popupContent += `Área (ha): ${feature.properties.area.toFixed(2)}<br>`;
                            }
                            if (feature.properties.condicao) {
                                popupContent += `Condição: ${feature.properties.condicao}<br>`;
                            }
                            layer.bindPopup(popupContent);
                        }
                    }
                })
                car.addTo(mapa);
                console.log('Car', car)
                cars.push(car)
                console.log('cars.push', cars)
                console.log(`Dados do CAR para o município ${codigoMunicipioIBGE} carregados no mapa.`);

                // Opcional: Ajustar o zoom do mapa para a camada carregada
                // if (mapa.hasLayer(geojsonLayer)) { // Supondo que geojsonLayer é a referência retornada por L.geoJSON
                //     mapa.fitBounds(geojsonLayer.getBounds());
                // }

            } else {
                console.log(`Nenhuma feição encontrada para o município ${codigoMunicipioIBGE} ou o GeoJSON está vazio.`);
                alert(`Nenhuma feição encontrada para o município ${codigoMunicipioIBGE}. Verifique o código ou a disponibilidade dos dados.`);
            }
        })
        .catch(error => {
            console.error(`Erro ao carregar os dados do CAR para o município ${codigoMunicipioIBGE}:`, error);
            alert(`Erro ao carregar dados do CAR: ${error.message}. Verifique o console para mais detalhes.`);
        });
    return cars;
}
export const carregarZipFromURL2 = async (url: string, estilo: any) => {
    // const poligonos = L.featureGroup()
    // const poligonos = new L.FeatureGroup()
    const poligonos: Array<L.GeoJSON> = []
    if (url) {
        const response = await fetch(url)
        if (response.ok) {
            const file = await response.arrayBuffer();
            const zipFile = await new JSZip().loadAsync(file);

            const shpFile = zipFile.file(/\.shp$/)[0];
            // const shxFile = zipFile.file(/\.shx$/)[0];

            // if (shpFile && shxFile) {
            if (shpFile) {
                const shpArrayBuffer = await shpFile.async('arraybuffer');
                // const shxArrayBuffer = await shxFile.async('arraybuffer');
                // const geojson = shpjs.combine([shpArrayBuffer, shxArrayBuffer]);

                // Realize qualquer processamento adicional necessário com o geojson carregado
                // console.log('GeoJSON carregado:', geojson);
                const buffer = await shapefile.openShp(shpArrayBuffer)
                var result
                do {
                    result = await buffer.read();
                    if (!result.done) {
                        // poligonos.addLayer(L.geoJSON(result.value, { style: estilo }))
                        poligonos.push(L.geoJSON(result.value, { style: estilo }))
                    }
                } while (!result.done)
            } else {
                console.error('Arquivos .shp e .shx não encontrados no arquivo ZIP.');
            }
        };
    }
    return poligonos;
}



window.Buffer = Buffer;

export const carregarZipFromURLDBF = async (url: string, estilo?: any) => {
    // const poligonos = L.featureGroup()
    const poligonos = new L.FeatureGroup()
    // const poligonos: Array<L.GeoJSON> = []
    if (url) {
        const response = await fetch(url)
        if (response.ok) {
            const file = await response.arrayBuffer();
            const zipFile = await new JSZip().loadAsync(file);

            const shpFile = zipFile.file(/\.shp$/)[0];
            // const shxFile = zipFile.file(/\.shx$/)[0];
            const dbfFile = zipFile.file(/\.dbf$/)[0];

            // if (shpFile && shxFile) {
            if (shpFile) {
                const shpArrayBuffer = await shpFile.async('arraybuffer');
                // const shxArrayBuffer = await shxFile.async('arraybuffer');
                // const geojson = shpjs.combine([shpArrayBuffer, shxArrayBuffer]);
                const dbfArrayBuffer = await dbfFile.async('arraybuffer');

                // Realize qualquer processamento adicional necessário com o geojson carregado
                // console.log('GeoJSON carregado:', geojson);
                const buffer = await shapefile.openShp(shpArrayBuffer)

                const dbfBuffer = Buffer.from(dbfArrayBuffer);
                let datatable: DataTable = await Dbf.read(dbfBuffer); // Implementar readDBF
                // Convert ArrayBuffer to a format dbf-reader can work with
                // Converter ArrayBuffer para Uint8Array

                var result
                var index = 0
                do {
                    result = await buffer.read();
                    if (!result.done) {
                        var poligono
                        if (estilo)
                            poligono = L.geoJSON(result.value, { style: estilo })
                        else
                            poligono = L.geoJSON(result.value)
                        poligonos.addLayer(poligono)
                        if (datatable) {
                            poligono.bindPopup(popUpForCar(datatable.rows[index], poligono))
                        }
                    }
                    index++
                } while (!result.done)
            } else {
                console.error('Arquivos .shp e .shx não encontrados no arquivo ZIP.');
            }
        };
    }
    return poligonos;
}
export const carregarZipFromURL = async (url: string, estilo?: any) => {
    // const poligonos = L.featureGroup()
    const poligonos = new L.FeatureGroup()
    // const poligonos: Array<L.GeoJSON> = []
    if (url) {
        const response = await fetch(url, { cache: 'no-store' })
        if (response.ok) {
            const file = await response.arrayBuffer();
            const zipFile = await new JSZip().loadAsync(file);

            const shpFile = zipFile.file(/\.shp$/)[0];
            // const shxFile = zipFile.file(/\.shx$/)[0];

            // if (shpFile && shxFile) {
            if (shpFile) {
                const shpArrayBuffer = await shpFile.async('arraybuffer');
                // const shxArrayBuffer = await shxFile.async('arraybuffer');
                // const geojson = shpjs.combine([shpArrayBuffer, shxArrayBuffer]);

                // Realize qualquer processamento adicional necessário com o geojson carregado
                // console.log('GeoJSON carregado:', geojson);
                const buffer = await shapefile.openShp(shpArrayBuffer)
                var result
                do {
                    result = await buffer.read();
                    if (!result.done) {
                        if (estilo)
                            poligonos.addLayer(L.geoJSON(result.value, { style: estilo }))
                        else
                            poligonos.addLayer(L.geoJSON(result.value))
                    }
                } while (!result.done)
            } else {
                console.error('Arquivos .shp e .shx não encontrados no arquivo ZIP.');
            }
        };
    }
    return poligonos;
}
export const clearMap = (mapa: L.Map | null) => {
    //console.log('Limpando o mapa', mapa)
    mapa?.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Polygon) layer.remove()
        if (layer instanceof L.Polyline) layer.remove()
        if (layer instanceof L.Marker) layer.remove()
        if (layer instanceof L.Circle) layer.remove()
        if (layer instanceof L.CircleMarker) layer.remove()
        if (layer instanceof L.FeatureGroup) layer.remove()
    })
}
// export const removeAllPolylines = (mapa: L.Map | null) => {
//     mapa?.eachLayer((layer: L.Layer) => {
//         if (layer instanceof L.Polygon) console.log('is poligono')
//         else if (layer instanceof L.Polyline) layer.remove()
//     })
// }
// export const carregarZipFromURLLikePolyline = async (url: string, estilo: any) => {
//     const poligonos = await carregarZipFromURL(url, estilo)
//     const polylines = L.featureGroup()
//     poligonos.eachLayer((poligono: any) => {
//         // polylines.addLayer(L.polyline(poligono.getLayers()[0]._latlngs, estilo))
//         polylines.addLayer(L.polyline([poligono.getLayers()[0].getLatLngs(), poligono.getLayers()[0].getLatLngs()[0]], estilo))
//     })
//     return polylines
// }

//TESTAR https://github.com/gabriel-russo/Leaflet.BetterFileLayer
export const carregarShpFromURL = (url: string, mapa: any, estilo: any, popUp: string) => {
    if (url) {
        shapefile.openShp(url).then((a: any) => {
            a.read().then(function log(result: any): any {
                if (result.done) return;
                L.geoJSON(result.value, { style: estilo }).bindPopup(popUp).setZIndex(10).addTo(mapa);
                return a.read().then(log);
            })
        });
    }
}
export const circleToPolygon = (mapa: L.Map) => {
    mapa.eachLayer((layer: any) => {
        // Se a forma desenhada for um círculo, converta-a em um polígono
        if (layer instanceof L.Circle) {
            const polygon = L.PM.Utils.circleToPolygon(layer, 60)
            mapa.addLayer(polygon);
            mapa.removeLayer(layer);
        }
    })
}

export const searchCoordinates = (mapa: L.Map | null, latitude: any, longitude: any) => {
    const userLocation: LatLngExpression = [latitude, longitude];
    mapa?.flyTo(userLocation, 20, {
        duration: 2,
        easeLinearity: 0.25
    })
    mapa?.addLayer(L.marker(userLocation).bindPopup('Sua localização é:<br>Latitude: ' + latitude + '<br>Longitude: ' + longitude).openPopup());
}

export const layerToPolygon = (layer: L.Layer | any) => {
    const latlngs = layer.getLatLngs()[0]
    // console.log('LatLngs', latlngs)
    var coordinates = latlngs.map((latlng: any) => [latlng.lng, latlng.lat])
    coordinates = [...coordinates, coordinates[0]]
    // console.log('Coordinates', coordinates)
    return turf.polygon([coordinates])
}
export const centro = (layer: L.Layer | any) => {
    try {
        return turf.centerOfMass(layerToPolygon(layer))
    } catch (e) {
        // console.log('Erro no calculo de centro 1:', e)
        try {
            return turf.centerOfMass(layerToPolygon(layer.getLayers()[0]))
        } catch (e) {
            // console.log('Erro no calculo de centro 2:', e)
        }
    }
    return null
}
export const perimetro = (layer: L.Layer | any) => {
    try {
        return turf.length(turf.polygonToLine(layerToPolygon(layer)))
    } catch (e) {
        // console.log('Erro no calculo de perimetro 1:', e)
        try {
            return turf.length(turf.polygonToLine(layerToPolygon(layer.getLayers()[0])))
        } catch (e) {
            // console.log('Erro no calculo de perimetro 2:', e)
        }
    }
    return 0
}
export const perimetroInKm = (layer: L.Layer | any) => {
    return perimetro(layer).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km'
}
export const area = (layer: L.Layer | any) => {
    var area = 0
    if (layer instanceof L.Circle) {
        const radius = layer.getRadius();
        area = Math.PI * Math.pow(radius, 2);
    } else {
        try {
            area = turf.area(layerToPolygon(layer))
        } catch (e) {
            // console.log('Erro no calculo de area 1:', e)
            try {
                area = turf.area(layerToPolygon(layer.getLayers()[0]))
            } catch (e) {
                // console.log('Erro no calculo de area 2:', e)
            }
        }
    }
    return area
}
export const areaInM2Of = (layer: L.Layer | any) => {
    return area(layer).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²'
}
export const areaInHaOf = (layer: L.Layer | any) => {
    return (area(layer) / 1e4).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ha'
}
export const areaInKm2Of = (layer: L.Layer | any) => {
    return (area(layer) / 1e6).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km²'
}
export const coord2Text = (coord: number) => {
    return coord.toLocaleString('pt-BR', { minimumFractionDigits: 6, maximumFractionDigits: 6 })
}
type CarType = {
    cod_tema: string
    nom_tema: string
    cod_imovel: string
    mod_fiscal: string
    num_area: string
    ind_status: string
    ind_tipo: string
    des_condic: string
    municipio: string
    cod_estado: string
}
export const popUpForCar = (car: CarType, poligono: any) => {
    return '<h1>CAR</h1>' +
        '<hr>' +
        '<b>Código: </b>' + car.cod_imovel.replace(car.cod_estado + '-' + car.municipio + '-', '').toUpperCase() + '<br />' +
        '<b>Unidade Federativa: </b>' + car.cod_estado + '<br />' +
        '<b>Município: </b>' + car.municipio + '<br />' +
        '<b>Condição Externa: </b>' + car.des_condic + '<br />' +
        '<b>Situação do Cadastro: </b>' + car.ind_status + '<br />' +
        '<b>Tipo de imóvel: </b>' + car.ind_tipo + '<br />' +
        // cod_tema: "AREA_IMOVEL"
        // mod_fiscal: 0.23
        // nom_tema: "Area do Imovel"
        '<b>Área cadastrada: </b>' + car.num_area + '<br />' +
        '<b>Área calculada aprox.: </b>' + areaInHaOf(poligono)
}

export const popUpForPropriedade = (propriedade: ImovelType, poligono?: any) => {
    var text = '<h1>' + propriedade.nome.toUpperCase() + '<div style="-moz-transform: scaleX(-1);-webkit-transform: scaleX(-1);-o-transform: scaleX(-1);transform: scaleX(-1);-ms-filter: fliph;filter: fliph;">🚜</div></h1>' +
        '<hr>'
    text += propriedade.proprietario?.pessoa?.length > 0 ? '<b>Proprietário: </b>' + propriedade.proprietario?.pessoa?.nome_razao + '<br />' : ''
    text += `<b>Localidade: </b>${propriedade.localidade}<br />` +
        `<b>Acesso: </b>${propriedade.acesso}<br />`
    text += poligono ? `<b>Área aprox.: </b>${areaInHaOf(poligono)}<br />` : ''
    // text += poligono ? `<b>Bounds: </b>${poligono.getBounds().toBBoxString()}` : ''
    return text
}
// export const popUpForWarning = (warning: WarningType, poligono: any) => {
//     const a = '<p style="margin-top:5px;padding-top:0px;margin-bottom:5px;">' +
//         '<b>⚠️</b><br />' +
//         '<b>Detecção de ' + (warning.type === 's' ? 'soja! 🌾' : (warning.type === 'c' ? 'algodão! ☘️' : warning.type)) + '</b><br>' +
//         'Relatório: <a href="' + warning.report + '" target="_blank">link do PDF</a>' +
//         '</p>' +
//         '<table>' +
//         '<tr>' +
//         '<th>Imagem via satélite</th>' +
//         '<th>Detecção processada</th>' +
//         '</tr>' +
//         '<tr>' +
//         '<td>' +
//         '<img src=' + warning.shapeImage + ' height="100" />' +
//         '</td>' +
//         '<td>' +
//         '<img src=' + warning.pointImage + ' height="100" />' +
//         '</td>' +
//         '</tr>' +
//         '</table>'
//     return a
// }
const IBGE_URL = 'https://servicodados.ibge.gov.br/api/v4/malhas/'
export const popUpForMunicipio = (municipio: any, poligono: any) => {
    const center: any = centro(poligono)?.geometry.coordinates
    return '<h1 style="margin:0px">' + municipio.nome + '<img height="20px" src="' + IBGE_URL + 'municipios/' + municipio.id + '" />' + '</h1>' +
        '<b>Código: </b>' + municipio.id +
        '<hr><b>Região Imediata: </b>' + municipio["regiao-imediata"].nome + ' (' + municipio["regiao-imediata"].id + ') ' +
        '<img height="12px" src="' + IBGE_URL + 'regioes-imediatas/' + municipio["regiao-imediata"].id + '" />' +
        '<br><b>Região Intermediária: </b>' + municipio["regiao-imediata"]["regiao-intermediaria"].nome + ' (' + municipio["regiao-imediata"]["regiao-intermediaria"].id + ') ' +
        '<img height="12px" src="' + IBGE_URL + 'regioes-intermediarias/' + municipio["regiao-imediata"]["regiao-intermediaria"].id + '" />' +
        '<hr><b>Microrregião: </b>' + municipio.microrregiao.nome + ' (' + municipio.microrregiao.id + ') ' +
        // '<img height="12px" src="' + IBGE_URL + 'microrregioes/' + municipio.microrregiao.id + '" />' +
        '<br><b>Mesorregião: </b>' + municipio.microrregiao.mesorregiao.nome + ' (' + municipio.microrregiao.mesorregiao.id + ') ' +
        // '<img height="12px" src="' + IBGE_URL + 'mesorregioes/' + municipio.microrregiao.mesorregiao.id + '" />' +
        '<hr><b>Estado: </b>' + municipio.microrregiao.mesorregiao.UF.nome + ' - ' + municipio.microrregiao.mesorregiao.UF.sigla + ' (' + municipio.microrregiao.mesorregiao.UF.id + ') ' +
        '<img height="12px" src="' + IBGE_URL + 'estados/' + municipio.microrregiao.mesorregiao.UF.id + '" />' +
        '<br><b>Região: </b>' + municipio.microrregiao.mesorregiao.UF.regiao.nome + ' - ' + municipio.microrregiao.mesorregiao.UF.regiao.sigla + ' (' + municipio.microrregiao.mesorregiao.UF.regiao.id + ') ' +
        '<img height="12px" src="' + IBGE_URL + 'regioes/' + municipio.microrregiao.mesorregiao.UF.regiao.id + '" />' +
        '<hr><b>Área aprox.: </b>' + areaInKm2Of(poligono) +
        '<br><b>Perímetro aprox.: </b>' + perimetroInKm(poligono) +
        '<br><b>Ponto central: </b>' + (center ? '<br><b style="margin-left:10px">Latitude: </b>' + coord2Text(center[1]) + ' <b>Longitude: </b>' + coord2Text(center[0]) : 'Não foi possível localizar')
}
export const estiloContorno = { color: 'red', fillColor: 'red', fillOpacity: 0, weight: 2, fill: false }
export const estiloArea = { color: 'cyan', fillColor: 'cyan', fillOpacity: 0.05, weight: 1, fill: true }
export const estiloSelected = { color: 'purple', fillColor: 'purple', fillOpacity: 0.3, weight: 4, fill: true }

export const refreshingMap = (map: any, setLoading: Function) => {
    map.on('moveend', function () {
        setLoading(false)
    });
    map.on('zoom', function () {
        setLoading(true)
    })
    map.on('zoomend', function () {
        setLoading(false)
    })
    map.on('move', function () {
        setLoading(true)
    });
}

export const loadMunicipios = async (mapa: L.Map | null, municipios: Array<any>, progress?: any) => {
    if (mapa) {
        clearMap(mapa)
        await municipios.map(async (municipio: any, index: number, array: any[]) => {
            await loadMunicipio(mapa, municipio, estiloArea, false)
            progress && progress(index)
        })
    }
}

export const loadLote = async (mapa: L.Map | null, lote: any, estilo: any, fitBounds: boolean) => {
    if (mapa && lote.geojson) {
        const geojsonLayer = L.geoJSON(JSON.parse(lote.geojson), { style: estilo });
        geojsonLayer.bindPopup(popUpForLote(lote, geojsonLayer));
        geojsonLayer.addTo(mapa);
        if (fitBounds) {
            mapa.fitBounds(geojsonLayer.getBounds());
        }
    }
};
export const loadLotes = async (mapa: L.Map | null, lotes: Array<any>, estilo?: any) => {
    for (const lote of lotes) {
        const poligonos = await carregarZipFromURL(lote.poligono, estilo ? estilo : estiloSelected);
        poligonos.eachLayer((poligono: any) => {
            poligono.bindPopup(popUpForLote(lote, poligono));
            if (mapa) mapa.addLayer(poligono);
        });
    }
}
export const popUpForLote = (lote: any, poligono?: any) => {
    let text = `<h1>Lote: ${lote.id || 'N/A'}</h1><hr>`;
    text += `<b>Propriedade:</b> ${lote.propriedade?.nome || 'N/A'}<br>`;
    text += `<b>Área aprox.:</b> ${poligono ? areaInHaOf(poligono) : 'N/A'}<br>`;
    return text;
};

type Color = string;

export function generateColorPalette(nColors: number): Color[] {
    const basicColors: Color[] = [
        // '#F94144', '#F3722C', '#F8961E', '#F9844A', '#F9C74F', '#90BE6D', '#43AA8B', '#4D908E', '#577590', '#277DA1'
        // '#ff0000', '#ff8700', '#ffd300', '#deff0a', '#a1ff0a', '#0aff99', '#0aefff', '#147df5', '#580aff', '#be0aff'
        // '#ffadad', '#ffd6a5', '#fdffb6', '#caffbf', '#9bf6ff', '#a0c4ff', '#bdb2ff', '#ffc6ff', '#fffffc'
        // '#ff2020', '#ff9819', '#f8ff27', '#4eff2a', '#12ebff', '#166fff', '#4423ff', '#ff31ff', '#ffff53'
        //'#ff2020', '#ff9819', '#f8ff27', '#4eff2a', '#12ebff', '#4423ff', '#ff31ff', '#ffff53'
        '#ff2020', '#ff9819', '#f8ff27', '#4eff2a', '#12ebff', '#4423ff', '#ff31ff', '#ffff53', '#C00000', '#00B0B0', '#AA00FF', '#7FFF00', '#50C8FF', '#CC5500', '#FF1493', '#007000', '#300090', '#FFC300'
        // '#6a00ff', '#ff00ff', '#ff0040', '#ff9500', '#ffff00', '#aaff00', '#00ff15', '#00ffff', '#0095ff'
        // '#33a8c7', '#52e3e1', '#a0e426', '#fdf148', '#ffab00', '#f77976', '#f050ae', '#d883ff', '#9336fd'
        // "#FF0000", "#00FF00", "#0000FF", // Red, Green, Blue
        // "#FFFF00", "#FF00FF", "#00FFFF", // Yellow, Magenta, Cyan
        // "#000000", "#FFFFFF"            // Black, White
    ];

    const colorPalette: Color[] = [];
    let i = 0
    for (let j = 0; j < nColors; j++) {
        i = j === basicColors.length ? 0 : j
        colorPalette.push(basicColors[i++])
    }

    return colorPalette;
}

export const getColors4Meso = (municipios: Array<any>) => {
    const mesoregioesMap = new Map();

    municipios.forEach((m: any) => {
        const mesorregiao = m.microrregiao.mesorregiao;
        // Se o ID da mesorregião ainda não estiver no Map, adiciona.
        if (!mesoregioesMap.has(mesorregiao.id)) {
            mesoregioesMap.set(mesorregiao.id, mesorregiao);
        }
    });
    const colors = generateColorPalette(mesoregioesMap.keys().toArray().length);

    const colorsMeso: Array<any> = []
    for (let i = 0; i < mesoregioesMap.size; i++) {
        colorsMeso.push({ color: colors.at(i), meso: mesoregioesMap.keys().toArray().at(i) });
    }
    return colorsMeso

}
export const loadMunicipioss = (mapa: L.Map, municipios: Array<any>, progress?: any) => {
    if (mapa) {
        clearMap(mapa)

        const colors = getColors4Meso(municipios)
        let collectiveBounds = L.latLngBounds([]);
        municipios.map((municipio: any, index: number, array: any[]) => {
            collectiveBounds.extend(loadMapaMunicipio(mapa, municipio, { ...estiloArea, color: colors.find((c: any) => c.meso === municipio.microrregiao.mesorregiao.id).color }, false).getBounds())
            // loadMapaMunicipio(mapa, municipio, { ...estiloArea, color: colors.find((c: any) => c.meso === municipio.microrregiao.mesorregiao.id).color }, false)
            progress && progress(index)
        })
        if (collectiveBounds.isValid())
            mapa.fitBounds(collectiveBounds);
    }
}

export const loadMapaMunicipio = (mapa: L.Map | null, municipio: any, estilo = estiloArea, flyTo = true) => {
    if (mapa)
        try {
            const poligono: L.GeoJSON | any = L.geoJSON(municipio.mapa)
            poligono.bindPopup(popUpForMunicipio(municipio, poligono))
            poligono.setStyle(estilo)
            mapa?.addLayer(poligono)
            if (flyTo)
                mapa.flyToBounds(poligono.getBounds())
            return poligono
        } catch (e: any) {
            // console.log('Erro no carregamento do municipio ' + municipio.nome + ":", municipio)
            // console.log('Descrição do erro', e)
        }
    return null
}
export type CAR = {
    poligono: L.GeoJSON,
    codigo: string,

}
export type AllType = {
    municipio: L.GeoJSON | null
    cars: Array<CAR>
}
export const loadMunicipio = async (mapa: L.Map | null, municipio: any, estilo = estiloArea, flyTo = true) => {
    if (mapa) {
        try {
            const response = await fetch(IBGE_URL + 'municipios/' + municipio.id + '?formato=application/vnd.geo+json')
            const data = await response.json()
            //console.log('Mapa Data Json: ', data)
            const poligono: L.GeoJSON | any = L.geoJSON(data)
            poligono.bindPopup(popUpForMunicipio(municipio, poligono))
            poligono.setStyle(estilo)
            mapa?.addLayer(poligono)

            if (flyTo)
                mapa.flyToBounds(poligono.getBounds())
            return poligono
        } catch (e: any) {
            console.log('Erro no carregamento do municipio ' + municipio.nome, municipio)
            console.log('Descrição do erro', e)
        }
    }
    return null
}



// export const loadMunicipioCars = async (mapa: L.Map | null, municipio: any, estilo = estiloArea, flyTo = true, car = false, navigate: any, selectCar: Function, setCar: Function, setCars: Function) => {
//     var all: AllType = { municipio: null, cars: [] }
//     if (mapa) {
//         try {
//             const response = await fetch(IBGE_URL + 'municipios/' + municipio.id + '?formato=application/vnd.geo+json')
//             const data = await response.json()
//             //console.log('Mapa Data Json: ', data)
//             const poligono: L.GeoJSON | any = L.geoJSON(data)
//             poligono.bindPopup(popUpForMunicipio(municipio, poligono))
//             poligono.setStyle(estilo)
//             mapa?.addLayer(poligono)

//             if (flyTo)
//                 mapa.flyToBounds(poligono.getBounds())
//             all = { ...all, municipio: poligono }
//         } catch (e: any) {
//             console.log('Erro no carregamento do municipio ' + municipio.nome, municipio)
//             console.log('Descrição do erro', e)
//         }
//         if (car)
//             try {
//                 const cars = await api.getData(api.api + 'cars/?municipio=' + municipio.id, navigate, () => { })
//                 //console.log('Cars Json: ', cars)
//                 all = { ...all }
//                 cars.map(async (c: any) => {
//                     //console.log('Car', c)
//                     const poligonos = await carregarZipFromURLDBF(c.car, estiloArea)
//                     poligonos.eachLayer(poligono => {
//                         // poligono.bindPopup(popUpForCar(c, poligono))
//                         // poligono.on('click', () => {selectCar(poligono, poligonoss)})
//                         mapa.addLayer(poligono)
//                         all.cars.push(poligono as L.GeoJSON)
//                     })
//                     all.cars.forEach((c) => {
//                         c.on('click', () => {
//                             selectCar(c, all.cars)
//                             setCar(c)
//                         })
//                     })
//                 })
//                 setCars(all.cars)
//                 // const poligono: L.GeoJSON | any = L.geoJSON(data)
//                 // poligono.bindPopup(popUpForMunicipio(municipio, poligono))
//                 // poligono.setStyle(estilo)
//                 // mapa?.addLayer(poligono)

//                 // if (flyTo)
//                 // mapa.flyToBounds(poligono.getBounds())
//                 // return poligono
//             } catch (e: any) {
//                 console.log('Erro no carregamento do CAR do municipio ' + municipio.nome, municipio)
//                 console.log('Descrição do erro', e)
//             }
//     }
//     return all
// }

export const loadPropriedades = async (mapa: L.Map | null, propriedades: Array<any>, zoomIn: boolean) => {
    if (mapa) {
        let collectiveBounds = L.latLngBounds([]);

        for (const propriedade of propriedades) {
            const poligonos = await carregarZipFromURL(propriedade.poligono, {
                color: 'cyan',
                fillColor: 'cyan',
                fillOpacity: 0.05,
                weight: 1
            });
            poligonos.eachLayer((poligono: any) => {
                poligono.bindPopup(popUpForPropriedade(propriedade, poligono));
                mapa.addLayer(poligono);
                collectiveBounds.extend(poligono.getBounds());
            });
        }

        if (zoomIn && collectiveBounds.isValid())
            mapa.flyToBounds(collectiveBounds, {
                // padding: [-10, -10], // Boa prática para dar uma margem
                maxZoom: 10 // Impede o mapa de ficar muito afastado. Ajuste este valor!
            });
    }
}

// export const loadPropriedades = async (mapa: L.Map | null, propriedades: Array<any>, zoomIn: boolean) => {
//     if (mapa) {
//         let collectiveBounds = L.latLngBounds([]);

//         propriedades.forEach(async (propriedade: any) => {
//             const poligonos = await carregarZipFromURL(propriedade.poligono, {
//                 color: 'cyan',
//                 fillColor: 'cyan',
//                 fillOpacity: 0.05,
//                 weight: 1
//             })
//             poligonos.eachLayer(poligono => {
//                 poligono.bindPopup(popUpForPropriedade(propriedade, poligono))
//                 collectiveBounds.extend(mapa.addLayer(poligono).getBounds())
//             })
//         })

//         console.log('Collective Bounds', collectiveBounds)
//         console.log('Collective Bounds Valid', collectiveBounds.isValid())
//         console.log('Zoom In', zoomIn)

//         if (zoomIn && collectiveBounds.isValid())
//             mapa.flyToBounds(collectiveBounds);

//     }
// }

export const loadPropriedade = async (mapa: L.Map | null, propriedade: ImovelType, estilo?: any, flyTo?: boolean) => {
    if (mapa) {
        const poligonos = await carregarZipFromURL(propriedade.poligono, estilo ? estilo : {
            color: 'cyan',
            fillColor: 'cyan',
            fillOpacity: 0.05,
            weight: 1
        })
        poligonos.eachLayer(poligono => {
            poligono.bindPopup(popUpForPropriedade(propriedade, poligono))
            mapa.addLayer(poligono)
        })
        if (flyTo)
            mapa.flyToBounds(poligonos.getBounds())
        return poligonos;
    }

}

const gpsIconPNG = new L.Icon({
    iconUrl: Marker_PNG,
    iconSize: [40, 40], // size of the icon
    iconAnchor: [20, 40], // point of the icon which will correspond to marker's location

    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
});

const gpsIconSVG = L.divIcon({
    html: renderToString(<Marker />),
    iconSize: [800, 800],
    iconAnchor: [400, 800],
    popupAnchor: [0, 0],
});

export const goHome = (mapa: L.Map | null) => {
    if ("geolocation" in navigator) {
        navigator.geolocation?.getCurrentPosition(function (position: any) {
            mapa?.flyTo([position.coords.latitude, position.coords.longitude], 20, { duration: 2, easeLinearity: 0.25 })
            mapa?.addLayer(L.marker([position.coords.latitude, position.coords.longitude], { icon: gpsIconPNG }).bindPopup('Sua localização é:<br>Latitude: ' + position.coords.latitude + '<br>Longitude: ' + position.coords.longitude).openPopup());
        });
    } else {
        console.log("Geolocalização não é suportada neste navegador.");
    }
}

export function openFile(e: ChangeEvent<HTMLInputElement>, mapa: L.Map | null) {
    console.log('e', e)
    if (e.target.files) {
        const file = e.target.files[0]
        console.log('File', file)
        if (file) {
            if (file.name.split('.').pop() === 'kml') {
                console.log('Open KML')
                var reader = new FileReader();
                reader.readAsText(file);
                reader.onload = (e) => {
                    const parser = new DOMParser();
                    console.log('Reader Result:', reader.result)
                    if (reader.result) {
                        const content = parser.parseFromString(reader.result as string, "text/xml");

                        const geojson = togeojson.kml(content);
                        const poligono = L.geoJSON(geojson)
                        // poligono.addTo(map);
                        mapa?.addLayer(poligono)
                        // if (editableLayersRef.current)
                        //     editableLayersRef.current.addLayer(poligono)
                        mapa?.flyToBounds(poligono.getBounds())
                    }
                }
            }
            else if (file.name.split('.').pop() === 'zip') {
                console.log('Open ZIP')
                const reader = new FileReader();

                reader.onload = async (event: any) => {
                    const zipArrayBuffer = event.target.result;
                    const zip = new JSZip();
                    const zipFile = await zip.loadAsync(zipArrayBuffer);

                    const shpFile = zipFile.file(/\.shp$/)[0];
                    console.log('SHP FILE', shpFile)
                    const shxFile = zipFile.file(/\.shx$/)[0];

                    if (shpFile && shxFile) {
                        const shpArrayBuffer = await shpFile.async('arraybuffer');
                        // const shxArrayBuffer = await shxFile.async('arraybuffer');
                        console.log('SHP BUFFER', shpArrayBuffer)

                        // const geojson = shpjs.combine([shpArrayBuffer, shxArrayBuffer]);
                        // Realize qualquer processamento adicional necessário com o geojson carregado
                        // console.log('GeoJSON carregado:', geojson);


                        shapefile.openShp(shpArrayBuffer).then((a: any) => {
                            console.log('open shp')
                            a.read().then(function log(result: any): any {
                                console.log('result', { geometry: result.value, properties: { _enableLayerEdit: true } })
                                if (result.done) return;
                                // if (editableLayersRef.current)
                                // editableLayersRef.current.addLayer(L.geoJSON(result.value))
                                var shape: any = L.geoJSON(result.value)
                                console.log('shape', shape)
                                shape.options = { ...shape.options, enable: true }
                                // console.log('Map', map)
                                // shape.addTo(map)
                                // shape.addTo(L.map(mapRef.current))
                                mapa?.addLayer(shape)
                                // if (editableLayersRef.current)
                                //     editableLayersRef.current.addLayer(shape)
                                // editableLayersRef.current.addLayer(
                                //   L.geoJSON(result.value,
                                //     {
                                //       style: {
                                //         color: 'gray',
                                //         // fillColor: 'gray',
                                //         fillOpacity: 0.2,
                                //       },
                                //     }));
                                mapa?.flyToBounds(shape.getBounds())
                                return a.read().then(log);
                            })
                        });

                    } else {
                        console.error('Arquivos .shp e .shx não encontrados no arquivo ZIP.');
                    }
                };

                reader.readAsArrayBuffer(file);
            }
        }
    }

}

export const salvarShapefile = async (mapa: L.Map | null) => {
    // Verifique se há formas editáveis para exportar
    // if (editableLayersRef.current && editableLayersRef.current.getLayers().length > 0) {

    // editableLayersRef.current.getLayers().forEach((layer: any) => {
    // Se a forma desenhada for um círculo, converta-a em um polígono
    //     if (layer instanceof L.Circle) {
    //         const polygon = L.PM.Utils.circleToPolygon(layer, 60)
    //         if (editableLayersRef.current) {
    //             editableLayersRef.current.addLayer(polygon);
    //             editableLayersRef.current.removeLayer(layer);
    //         }
    //     }
    // })

    var fg = L.featureGroup();
    if (mapa) {
        circleToPolygon(mapa)
        mapa.eachLayer((layer) => {
            if (layer instanceof L.Polygon) {
                fg.addLayer(layer);
            }
        });
        // console.log(fg.toGeoJSON());

        // Converta as formas editáveis para o formato que a biblioteca shp-write espe  ra
        // const geojson: any = editableLayersRef.current.toGeoJSON();
        const geojson: any = fg.toGeoJSON()
        const options: any = {
            // folder: "dados",
            filename: "fazenda",
            outputType: "blob",
            compression: "STORE",
            types: {
                // point: "mypoints",
                polygon: "polygons",
                // polyline: "mylines",
            },
            // prj: 'PROJCS["Amersfoort / RD New",GEOGCS["Amersfoort",DATUM["D_Amersfoort",SPHEROID["Bessel_1841",6377397.155,299.1528128]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Stereographic_North_Pole"],PARAMETER["standard_parallel_1",52.15616055555555],PARAMETER["central_meridian",5.38763888888889],PARAMETER["scale_factor",0.9999079],PARAMETER["false_easting",155000],PARAMETER["false_northing",463000],UNIT["Meter",1]]'
        };

        // Use a biblioteca shp-write para criar o arquivo shapefile
        // const shapefileBuffer: any = shp.zip(geojson, options);

        shp.download(geojson, options)

    } else {
        alert('Não há formas editáveis para exportar.');
    }
};

export const optionsShpZip: any = {
    // folder: "dados",
    filename: "fazenda",
    outputType: "blob",
    compression: "STORE",
    types: {
        // point: "mypoints",
        polygon: "polygons",
        // polyline: "mylines",
    },
    // prj: 'PROJCS["Amersfoort / RD New",GEOGCS["Amersfoort",DATUM["D_Amersfoort",SPHEROID["Bessel_1841",6377397.155,299.1528128]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Stereographic_North_Pole"],PARAMETER["standard_parallel_1",52.15616055555555],PARAMETER["central_meridian",5.38763888888889],PARAMETER["scale_factor",0.9999079],PARAMETER["false_easting",155000],PARAMETER["false_northing",463000],UNIT["Meter",1]]'
}
export const getShapefileBuffer2 = async (mapa: L.Map | null) => {
    var fg = L.featureGroup();
    if (mapa) {
        circleToPolygon(mapa)
        mapa.eachLayer((layer) => { if (layer instanceof L.Polygon) fg.addLayer(layer) });
    }
    return getShpZipBufferFromFeatureGroup(fg)
}

export const getShpZipBufferFromFeatureGroup = async (polygon: L.FeatureGroup) => {
    const layer = polygon.getLayers()[0]
    if (layer instanceof L.Circle) {
        const circleLayer = L.PM.Utils.circleToPolygon(layer, 60)
        polygon.removeLayer(layer)
        polygon.addLayer(circleLayer)
    }
    const json = polygon.toGeoJSON() as GeoJSON.FeatureCollection<GeoJSON.Geometry, any>
    return await shp.zip(json, optionsShpZip)
}

export const getShapefileBuffer = async (mapa: L.Map | null) => {
    console.log('Mapa', mapa)

    var fg = L.featureGroup();
    if (mapa) {
        circleToPolygon(mapa)
        mapa.eachLayer((layer) => {
            // console.log('Count', mapa.get)
            console.log('Layer', layer)
            if (layer instanceof L.Polygon) {
                fg.addLayer(layer);
            }
        });
        // console.log(fg.toGeoJSON());

        // Converta as formas editáveis para o formato que a biblioteca shp-write espe  ra
        // const geojson: any = editableLayersRef.current.toGeoJSON();
        const geojson: any = fg.toGeoJSON()

        const options: any = {
            // folder: "dados",
            filename: "fazenda",
            outputType: "blob",
            compression: "STORE",
            types: {
                // point: "mypoints",
                polygon: "polygons",
                // polyline: "mylines",
            },
            // prj: 'PROJCS["Amersfoort / RD New",GEOGCS["Amersfoort",DATUM["D_Amersfoort",SPHEROID["Bessel_1841",6377397.155,299.1528128]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Stereographic_North_Pole"],PARAMETER["standard_parallel_1",52.15616055555555],PARAMETER["central_meridian",5.38763888888889],PARAMETER["scale_factor",0.9999079],PARAMETER["false_easting",155000],PARAMETER["false_northing",463000],UNIT["Meter",1]]'
        };

        // Use a biblioteca shp-write para criar o arquivo Shapefile
        const shapefileBuffer: any = await shp.zip(geojson, options);
        console.log('Buffer', shapefileBuffer)
        return shapefileBuffer;
    }

}


// L.TileLayer.Provider.providers = {
//     OpenStreetMap: {
//         url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 19,
//             attribution:
//                 '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         },
//         variants: {
//             Mapnik: {},
//             DE: {
//                 url: 'https://tile.openstreetmap.de/{z}/{x}/{y}.png',
//                 options: {
//                     maxZoom: 18
//                 }
//             },
//             CH: {
//                 url: 'https://tile.osm.ch/switzerland/{z}/{x}/{y}.png',
//                 options: {
//                     maxZoom: 18,
//                     bounds: [[45, 5], [48, 11]]
//                 }
//             },
//             France: {
//                 url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
//                 options: {
//                     maxZoom: 20,
//                     attribution: '&copy; OpenStreetMap France | {attribution.OpenStreetMap}'
//                 }
//             },
//             HOT: {
//                 url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
//                 options: {
//                     attribution:
//                         '{attribution.OpenStreetMap}, ' +
//                         'Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> ' +
//                         'hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
//                 }
//             },
//             BZH: {
//                 url: 'https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
//                 options: {
//                     attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
//                     bounds: [[46.2, -5.5], [50, 0.7]]
//                 }
//             }
//         }
//     },
//     MapTilesAPI: {
//         url: 'https://maptiles.p.rapidapi.com/{variant}/{z}/{x}/{y}.png?rapidapi-key={apikey}',
//         options: {
//             attribution:
//                 '&copy; <a href="http://www.maptilesapi.com/">MapTiles API</a>, {attribution.OpenStreetMap}',
//             variant: 'en/map/v1',
//             // Get your own MapTiles API access token here : https://www.maptilesapi.com/
//             // NB : this is a demonstration key that comes with no guarantee and not to be used in production
//             apikey: '<insert your api key here>',
//             maxZoom: 19
//         },
//         variants: {
//             OSMEnglish: {
//                 options: {
//                     variant: 'en/map/v1'
//                 }
//             },
//             OSMFrancais: {
//                 options: {
//                     variant: 'fr/map/v1'
//                 }
//             },
//             OSMEspagnol: {
//                 options: {
//                     variant: 'es/map/v1'
//                 }
//             }
//         }
//     },
//     OpenSeaMap: {
//         url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
//         options: {
//             attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
//         }
//     },
//     OPNVKarte: {
//         url: 'https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 18,
//             attribution: 'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data {attribution.OpenStreetMap}'
//         }
//     },
//     OpenTopoMap: {
//         url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 17,
//             attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//         }
//     },
//     OpenRailwayMap: {
//         url: 'https://{s}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 19,
//             attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://www.OpenRailwayMap.org">OpenRailwayMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//         }
//     },
//     OpenFireMap: {
//         url: 'http://openfiremap.org/hytiles/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 19,
//             attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="http://www.openfiremap.org">OpenFireMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//         }
//     },
//     SafeCast: {
//         url: 'https://s3.amazonaws.com/te512.safecast.org/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 16,
//             attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://blog.safecast.org/about/">SafeCast</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//         }
//     },
//     Stadia: {
//         url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}{r}.{ext}',
//         options: {
//             minZoom: 0,
//             maxZoom: 20,
//             attribution:
//                 '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                 '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                 '{attribution.OpenStreetMap}',
//             variant: 'alidade_smooth',
//             ext: 'png'
//         },
//         variants: {
//             AlidadeSmooth: 'alidade_smooth',
//             AlidadeSmoothDark: 'alidade_smooth_dark',
//             OSMBright: 'osm_bright',
//             Outdoors: 'outdoors',
//             StamenToner: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_toner'
//                 }
//             },
//             StamenTonerBackground: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_toner_background'
//                 }
//             },
//             StamenTonerLines: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_toner_lines'
//                 }
//             },
//             StamenTonerLabels: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_toner_labels'
//                 }
//             },
//             StamenTonerLite: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_toner_lite'
//                 }
//             },
//             StamenWatercolor: {
//                 url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}.{ext}',
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_watercolor',
//                     ext: 'jpg',
//                     minZoom: 1,
//                     maxZoom: 16
//                 }
//             },
//             StamenTerrain: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_terrain',
//                     minZoom: 0,
//                     maxZoom: 18
//                 }
//             },
//             StamenTerrainBackground: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_terrain_background',
//                     minZoom: 0,
//                     maxZoom: 18
//                 }
//             },
//             StamenTerrainLabels: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_terrain_labels',
//                     minZoom: 0,
//                     maxZoom: 18
//                 }
//             },
//             StamenTerrainLines: {
//                 options: {
//                     attribution:
//                         '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
//                         '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
//                         '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
//                         '{attribution.OpenStreetMap}',
//                     variant: 'stamen_terrain_lines',
//                     minZoom: 0,
//                     maxZoom: 18
//                 }
//             }
//         }
//     },
//     Thunderforest: {
//         url: 'https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
//         options: {
//             attribution:
//                 '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
//             variant: 'cycle',
//             apikey: '<insert your api key here>',
//             maxZoom: 22
//         },
//         variants: {
//             OpenCycleMap: 'cycle',
//             Transport: {
//                 options: {
//                     variant: 'transport'
//                 }
//             },
//             TransportDark: {
//                 options: {
//                     variant: 'transport-dark'
//                 }
//             },
//             SpinalMap: {
//                 options: {
//                     variant: 'spinal-map'
//                 }
//             },
//             Landscape: 'landscape',
//             Outdoors: 'outdoors',
//             Pioneer: 'pioneer',
//             MobileAtlas: 'mobile-atlas',
//             Neighbourhood: 'neighbourhood'
//         }
//     },
//     CyclOSM: {
//         url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 20,
//             attribution: '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: {attribution.OpenStreetMap}'
//         }
//     },
//     Jawg: {
//         url: 'https://{s}.tile.jawg.io/{variant}/{z}/{x}/{y}{r}.png?access-token={accessToken}',
//         options: {
//             attribution:
//                 '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> ' +
//                 '{attribution.OpenStreetMap}',
//             minZoom: 0,
//             maxZoom: 22,
//             subdomains: 'abcd',
//             variant: 'jawg-terrain',
//             // Get your own Jawg access token here : https://www.jawg.io/lab/
//             // NB : this is a demonstration key that comes with no guarantee
//             accessToken: '<insert your access token here>',
//         },
//         variants: {
//             Streets: 'jawg-streets',
//             Terrain: 'jawg-terrain',
//             Sunny: 'jawg-sunny',
//             Dark: 'jawg-dark',
//             Light: 'jawg-light',
//             Matrix: 'jawg-matrix'
//         }
//     },
//     MapBox: {
//         url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}',
//         options: {
//             attribution:
//                 '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> ' +
//                 '{attribution.OpenStreetMap} ' +
//                 '<a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
//             tileSize: 512,
//             maxZoom: 18,
//             zoomOffset: -1,
//             id: 'mapbox/streets-v11',
//             accessToken: '<insert your access token here>',
//         }
//     },
//     MapTiler: {
//         url: 'https://api.maptiler.com/maps/{variant}/{z}/{x}/{y}{r}.{ext}?key={key}',
//         options: {
//             attribution:
//                 '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
//             variant: 'streets',
//             ext: 'png',
//             key: '<insert your MapTiler Cloud API key here>',
//             tileSize: 512,
//             zoomOffset: -1,
//             minZoom: 0,
//             maxZoom: 21
//         },
//         variants: {
//             Streets: 'streets',
//             Basic: 'basic',
//             Bright: 'bright',
//             Pastel: 'pastel',
//             Positron: 'positron',
//             Hybrid: {
//                 options: {
//                     variant: 'hybrid',
//                     ext: 'jpg'
//                 }
//             },
//             Toner: 'toner',
//             Topo: 'topo',
//             Voyager: 'voyager',
//             Ocean: 'ocean',
//             Backdrop: 'backdrop',
//             Dataviz: 'dataviz'
//         }
//     },
//     TomTom: {
//         url: 'https://{s}.api.tomtom.com/map/1/tile/{variant}/{style}/{z}/{x}/{y}.{ext}?key={apikey}',
//         options: {
//             variant: 'basic',
//             maxZoom: 22,
//             attribution:
//                 '<a href="https://tomtom.com" target="_blank">&copy;  1992 - ' + new Date().getFullYear() + ' TomTom.</a> ',
//             subdomains: 'abcd',
//             style: 'main',
//             ext: 'png',
//             apikey: '<insert your API key here>',
//         },
//         variants: {
//             Basic: 'basic',
//             Hybrid: 'hybrid',
//             Labels: 'labels'
//         }
//     },
//     Esri: {
//         url: 'https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
//         options: {
//             variant: 'World_Street_Map',
//             attribution: 'Tiles &copy; Esri'
//         },
//         variants: {
//             WorldStreetMap: {
//                 options: {
//                     attribution:
//                         '{attribution.Esri} &mdash; ' +
//                         'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
//                 }
//             },
//             DeLorme: {
//                 options: {
//                     variant: 'Specialty/DeLorme_World_Base_Map',
//                     minZoom: 1,
//                     maxZoom: 11,
//                     attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
//                 }
//             },
//             WorldTopoMap: {
//                 options: {
//                     variant: 'World_Topo_Map',
//                     attribution:
//                         '{attribution.Esri} &mdash; ' +
//                         'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
//                 }
//             },
//             WorldImagery: {
//                 options: {
//                     variant: 'World_Imagery',
//                     attribution:
//                         '{attribution.Esri} &mdash; ' +
//                         'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
//                 }
//             },
//             WorldTerrain: {
//                 options: {
//                     variant: 'World_Terrain_Base',
//                     maxZoom: 13,
//                     attribution:
//                         '{attribution.Esri} &mdash; ' +
//                         'Source: USGS, Esri, TANA, DeLorme, and NPS'
//                 }
//             },
//             WorldShadedRelief: {
//                 options: {
//                     variant: 'World_Shaded_Relief',
//                     maxZoom: 13,
//                     attribution: '{attribution.Esri} &mdash; Source: Esri'
//                 }
//             },
//             WorldPhysical: {
//                 options: {
//                     variant: 'World_Physical_Map',
//                     maxZoom: 8,
//                     attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
//                 }
//             },
//             OceanBasemap: {
//                 options: {
//                     variant: 'Ocean/World_Ocean_Base',
//                     maxZoom: 13,
//                     attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
//                 }
//             },
//             NatGeoWorldMap: {
//                 options: {
//                     variant: 'NatGeo_World_Map',
//                     maxZoom: 16,
//                     attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
//                 }
//             },
//             WorldGrayCanvas: {
//                 options: {
//                     variant: 'Canvas/World_Light_Gray_Base',
//                     maxZoom: 16,
//                     attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
//                 }
//             }
//         }
//     },
//     OpenWeatherMap: {
//         url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}',
//         options: {
//             maxZoom: 19,
//             attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
//             apiKey: '<insert your api key here>',
//             opacity: 0.5
//         },
//         variants: {
//             Clouds: 'clouds',
//             CloudsClassic: 'clouds_cls',
//             Precipitation: 'precipitation',
//             PrecipitationClassic: 'precipitation_cls',
//             Rain: 'rain',
//             RainClassic: 'rain_cls',
//             Pressure: 'pressure',
//             PressureContour: 'pressure_cntr',
//             Wind: 'wind',
//             Temperature: 'temp',
//             Snow: 'snow'
//         }
//     },
//     HERE: {
//         /*
//          * HERE maps, formerly Nokia maps.
//          * These basemaps are free, but you need an api id and app key. Please sign up at
//          * https://developer.here.com/plans
//          */
//         url:
//             'https://{s}.{base}.maps.api.here.com/maptile/2.1/' +
//             '{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
//             'app_id={app_id}&app_code={app_code}&lg={language}',
//         options: {
//             attribution:
//                 'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
//             subdomains: '1234',
//             mapID: 'newest',
//             'app_id': '<insert your app_id here>',
//             'app_code': '<insert your app_code here>',
//             base: 'base',
//             variant: 'normal.day',
//             maxZoom: 20,
//             type: 'maptile',
//             language: 'eng',
//             format: 'png8',
//             size: '256'
//         },
//         variants: {
//             normalDay: 'normal.day',
//             normalDayCustom: 'normal.day.custom',
//             normalDayGrey: 'normal.day.grey',
//             normalDayMobile: 'normal.day.mobile',
//             normalDayGreyMobile: 'normal.day.grey.mobile',
//             normalDayTransit: 'normal.day.transit',
//             normalDayTransitMobile: 'normal.day.transit.mobile',
//             normalDayTraffic: {
//                 options: {
//                     variant: 'normal.traffic.day',
//                     base: 'traffic',
//                     type: 'traffictile'
//                 }
//             },
//             normalNight: 'normal.night',
//             normalNightMobile: 'normal.night.mobile',
//             normalNightGrey: 'normal.night.grey',
//             normalNightGreyMobile: 'normal.night.grey.mobile',
//             normalNightTransit: 'normal.night.transit',
//             normalNightTransitMobile: 'normal.night.transit.mobile',
//             reducedDay: 'reduced.day',
//             reducedNight: 'reduced.night',
//             basicMap: {
//                 options: {
//                     type: 'basetile'
//                 }
//             },
//             mapLabels: {
//                 options: {
//                     type: 'labeltile',
//                     format: 'png'
//                 }
//             },
//             trafficFlow: {
//                 options: {
//                     base: 'traffic',
//                     type: 'flowtile'
//                 }
//             },
//             carnavDayGrey: 'carnav.day.grey',
//             hybridDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day'
//                 }
//             },
//             hybridDayMobile: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day.mobile'
//                 }
//             },
//             hybridDayTransit: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day.transit'
//                 }
//             },
//             hybridDayGrey: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.grey.day'
//                 }
//             },
//             hybridDayTraffic: {
//                 options: {
//                     variant: 'hybrid.traffic.day',
//                     base: 'traffic',
//                     type: 'traffictile'
//                 }
//             },
//             pedestrianDay: 'pedestrian.day',
//             pedestrianNight: 'pedestrian.night',
//             satelliteDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'satellite.day'
//                 }
//             },
//             terrainDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'terrain.day'
//                 }
//             },
//             terrainDayMobile: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'terrain.day.mobile'
//                 }
//             }
//         }
//     },
//     HEREv3: {
//         /*
//          * HERE maps API Version 3.
//          * These basemaps are free, but you need an API key. Please sign up at
//          * https://developer.here.com/plans
//          * Version 3 deprecates the app_id and app_code access in favor of apiKey
//          *
//          * Supported access methods as of 2019/12/21:
//          * @see https://developer.here.com/faqs#access-control-1--how-do-you-control-access-to-here-location-services
//          */
//         url:
//             'https://{s}.{base}.maps.ls.hereapi.com/maptile/2.1/' +
//             '{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
//             'apiKey={apiKey}&lg={language}',
//         options: {
//             attribution:
//                 'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
//             subdomains: '1234',
//             mapID: 'newest',
//             apiKey: '<insert your apiKey here>',
//             base: 'base',
//             variant: 'normal.day',
//             maxZoom: 20,
//             type: 'maptile',
//             language: 'eng',
//             format: 'png8',
//             size: '256'
//         },
//         variants: {
//             normalDay: 'normal.day',
//             normalDayCustom: 'normal.day.custom',
//             normalDayGrey: 'normal.day.grey',
//             normalDayMobile: 'normal.day.mobile',
//             normalDayGreyMobile: 'normal.day.grey.mobile',
//             normalDayTransit: 'normal.day.transit',
//             normalDayTransitMobile: 'normal.day.transit.mobile',
//             normalNight: 'normal.night',
//             normalNightMobile: 'normal.night.mobile',
//             normalNightGrey: 'normal.night.grey',
//             normalNightGreyMobile: 'normal.night.grey.mobile',
//             normalNightTransit: 'normal.night.transit',
//             normalNightTransitMobile: 'normal.night.transit.mobile',
//             reducedDay: 'reduced.day',
//             reducedNight: 'reduced.night',
//             basicMap: {
//                 options: {
//                     type: 'basetile'
//                 }
//             },
//             mapLabels: {
//                 options: {
//                     type: 'labeltile',
//                     format: 'png'
//                 }
//             },
//             trafficFlow: {
//                 options: {
//                     base: 'traffic',
//                     type: 'flowtile'
//                 }
//             },
//             carnavDayGrey: 'carnav.day.grey',
//             hybridDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day'
//                 }
//             },
//             hybridDayMobile: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day.mobile'
//                 }
//             },
//             hybridDayTransit: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.day.transit'
//                 }
//             },
//             hybridDayGrey: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'hybrid.grey.day'
//                 }
//             },
//             pedestrianDay: 'pedestrian.day',
//             pedestrianNight: 'pedestrian.night',
//             satelliteDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'satellite.day'
//                 }
//             },
//             terrainDay: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'terrain.day'
//                 }
//             },
//             terrainDayMobile: {
//                 options: {
//                     base: 'aerial',
//                     variant: 'terrain.day.mobile'
//                 }
//             }
//         }
//     },
//     FreeMapSK: {
//         url: 'https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
//         options: {
//             minZoom: 8,
//             maxZoom: 16,
//             subdomains: 'abcd',
//             bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
//             attribution:
//                 '{attribution.OpenStreetMap}, visualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
//         }
//     },
//     MtbMap: {
//         url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
//         options: {
//             attribution:
//                 '{attribution.OpenStreetMap} &amp; USGS'
//         }
//     },
//     CartoDB: {
//         url: 'https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png',
//         options: {
//             attribution: '{attribution.OpenStreetMap} &copy; <a href="https://carto.com/attributions">CARTO</a>',
//             subdomains: 'abcd',
//             maxZoom: 20,
//             variant: 'light_all'
//         },
//         variants: {
//             Positron: 'light_all',
//             PositronNoLabels: 'light_nolabels',
//             PositronOnlyLabels: 'light_only_labels',
//             DarkMatter: 'dark_all',
//             DarkMatterNoLabels: 'dark_nolabels',
//             DarkMatterOnlyLabels: 'dark_only_labels',
//             Voyager: 'rastertiles/voyager',
//             VoyagerNoLabels: 'rastertiles/voyager_nolabels',
//             VoyagerOnlyLabels: 'rastertiles/voyager_only_labels',
//             VoyagerLabelsUnder: 'rastertiles/voyager_labels_under'
//         }
//     },
//     HikeBike: {
//         url: 'https://tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 19,
//             attribution: '{attribution.OpenStreetMap}',
//             variant: 'hikebike'
//         },
//         variants: {
//             HikeBike: {},
//             HillShading: {
//                 options: {
//                     maxZoom: 15,
//                     variant: 'hillshading'
//                 }
//             }
//         }
//     },
//     BasemapAT: {
//         url: 'https://mapsneu.wien.gv.at/basemap/{variant}/{type}/google3857/{z}/{y}/{x}.{format}',
//         options: {
//             maxZoom: 19,
//             attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
//             type: 'normal',
//             format: 'png',
//             bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
//             variant: 'geolandbasemap'
//         },
//         variants: {
//             basemap: {
//                 options: {
//                     maxZoom: 20, // currently only in Vienna
//                     variant: 'geolandbasemap'
//                 }
//             },
//             grau: 'bmapgrau',
//             overlay: 'bmapoverlay',
//             terrain: {
//                 options: {
//                     variant: 'bmapgelaende',
//                     type: 'grau',
//                     format: 'jpeg'
//                 }
//             },
//             surface: {
//                 options: {
//                     variant: 'bmapoberflaeche',
//                     type: 'grau',
//                     format: 'jpeg'
//                 }
//             },
//             highdpi: {
//                 options: {
//                     variant: 'bmaphidpi',
//                     format: 'jpeg'
//                 }
//             },
//             orthofoto: {
//                 options: {
//                     maxZoom: 20, // currently only in Vienna
//                     variant: 'bmaporthofoto30cm',
//                     format: 'jpeg'
//                 }
//             }
//         }
//     },
//     nlmaps: {
//         url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/{variant}/EPSG:3857/{z}/{x}/{y}.png',
//         options: {
//             minZoom: 6,
//             maxZoom: 19,
//             bounds: [[50.5, 3.25], [54, 7.6]],
//             attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>'
//         },
//         variants: {
//             'standaard': 'standaard',
//             'pastel': 'pastel',
//             'grijs': 'grijs',
//             'water': 'water',
//             'luchtfoto': {
//                 'url': 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg',
//             }
//         }
//     },
//     NASAGIBS: {
//         url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
//         options: {
//             attribution:
//                 'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' +
//                 '(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
//             bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
//             minZoom: 1,
//             maxZoom: 9,
//             format: 'jpg',
//             time: '',
//             tilematrixset: 'GoogleMapsCompatible_Level'
//         },
//         variants: {
//             ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
//             ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
//             ViirsEarthAtNight2012: {
//                 options: {
//                     variant: 'VIIRS_CityLights_2012',
//                     maxZoom: 8
//                 }
//             },
//             ModisTerraLSTDay: {
//                 options: {
//                     variant: 'MODIS_Terra_Land_Surface_Temp_Day',
//                     format: 'png',
//                     maxZoom: 7,
//                     opacity: 0.75
//                 }
//             },
//             ModisTerraSnowCover: {
//                 options: {
//                     variant: 'MODIS_Terra_NDSI_Snow_Cover',
//                     format: 'png',
//                     maxZoom: 8,
//                     opacity: 0.75
//                 }
//             },
//             ModisTerraAOD: {
//                 options: {
//                     variant: 'MODIS_Terra_Aerosol',
//                     format: 'png',
//                     maxZoom: 6,
//                     opacity: 0.75
//                 }
//             },
//             ModisTerraChlorophyll: {
//                 options: {
//                     variant: 'MODIS_Terra_Chlorophyll_A',
//                     format: 'png',
//                     maxZoom: 7,
//                     opacity: 0.75
//                 }
//             }
//         }
//     },
//     NLS: {
//         // NLS maps are copyright National library of Scotland.
//         // http://maps.nls.uk/projects/api/index.html
//         // Please contact NLS for anything other than non-commercial low volume usage
//         //
//         // Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
//         //   z0-9  - 1:1m
//         //  z10-11 - quarter inch (1:253440)
//         //  z12-18 - one inch (1:63360)
//         url: 'https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
//         options: {
//             attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
//             bounds: [[49.6, -12], [61.7, 3]],
//             minZoom: 1,
//             maxZoom: 18,
//             subdomains: '0123',
//         }
//     },
//     JusticeMap: {
//         // Justice Map (http://www.justicemap.org/)
//         // Visualize race and income data for your community, county and country.
//         // Includes tools for data journalists, bloggers and community activists.
//         url: 'https://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
//         options: {
//             attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
//             // one of 'county', 'tract', 'block'
//             size: 'county',
//             // Bounds for USA, including Alaska and Hawaii
//             bounds: [[14, -180], [72, -56]]
//         },
//         variants: {
//             income: 'income',
//             americanIndian: 'indian',
//             asian: 'asian',
//             black: 'black',
//             hispanic: 'hispanic',
//             multi: 'multi',
//             nonWhite: 'nonwhite',
//             white: 'white',
//             plurality: 'plural'
//         }
//     },
//     GeoportailFrance: {
//         url: 'https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER={variant}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
//         options: {
//             attribution: '<a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>',
//             bounds: [[-75, -180], [81, 180]],
//             minZoom: 2,
//             maxZoom: 18,
//             // Get your own geoportail apikey here : http://professionnels.ign.fr/ign/contrats/
//             // NB : 'choisirgeoportail' is a demonstration key that comes with no guarantee
//             apikey: 'choisirgeoportail',
//             format: 'image/png',
//             style: 'normal',
//             variant: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
//         },
//         variants: {
//             plan: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
//             parcels: {
//                 options: {
//                     variant: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS',
//                     style: 'PCI vecteur',
//                     maxZoom: 20
//                 }
//             },
//             orthos: {
//                 options: {
//                     maxZoom: 19,
//                     format: 'image/jpeg',
//                     variant: 'ORTHOIMAGERY.ORTHOPHOTOS'
//                 }
//             }
//         }
//     },
//     OneMapSG: {
//         url: 'https://maps-{s}.onemap.sg/v3/{variant}/{z}/{x}/{y}.png',
//         options: {
//             variant: 'Default',
//             minZoom: 11,
//             maxZoom: 18,
//             bounds: [[1.56073, 104.11475], [1.16, 103.502]],
//             attribution: '<img src="https://docs.onemap.sg/maps/images/oneMap64-01.png" style="height:20px;width:20px;"/> New OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>'
//         },
//         variants: {
//             Default: 'Default',
//             Night: 'Night',
//             Original: 'Original',
//             Grey: 'Grey',
//             LandLot: 'LandLot'
//         }
//     },
//     USGS: {
//         url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
//         options: {
//             maxZoom: 20,
//             attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'
//         },
//         variants: {
//             USTopo: {},
//             USImagery: {
//                 url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}'
//             },
//             USImageryTopo: {
//                 url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'
//             }
//         }
//     },
//     WaymarkedTrails: {
//         url: 'https://tile.waymarkedtrails.org/{variant}/{z}/{x}/{y}.png',
//         options: {
//             maxZoom: 18,
//             attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://waymarkedtrails.org">waymarkedtrails.org</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//         },
//         variants: {
//             hiking: 'hiking',
//             cycling: 'cycling',
//             mtb: 'mtb',
//             slopes: 'slopes',
//             riding: 'riding',
//             skating: 'skating'
//         }
//     },
//     OpenAIP: {
//         url: 'https://{s}.tile.maps.openaip.net/geowebcache/service/tms/1.0.0/openaip_basemap@EPSG%3A900913@png/{z}/{x}/{y}.{ext}',
//         options: {
//             attribution: '<a href="https://www.openaip.net/">openAIP Data</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-NC-SA</a>)',
//             ext: 'png',
//             minZoom: 4,
//             maxZoom: 14,
//             tms: true,
//             detectRetina: true,
//             subdomains: '12'
//         }
//     },
//     OpenSnowMap: {
//         url: 'https://tiles.opensnowmap.org/{variant}/{z}/{x}/{y}.png',
//         options: {
//             minZoom: 9,
//             maxZoom: 18,
//             attribution: 'Map data: {attribution.OpenStreetMap} & ODbL, &copy; <a href="https://www.opensnowmap.org/iframes/data.html">www.opensnowmap.org</a> <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
//         },
//         variants: {
//             pistes: 'pistes',
//         }
//     },
//     AzureMaps: {
//         url:
//             'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
//             '&tilesetId={variant}&x={x}&y={y}&zoom={z}&language={language}'+
//             '&subscription-key={subscriptionKey}',
//         options: {
//             attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile for details.',
//             apiVersion: '2.0',
//             variant: 'microsoft.imagery',
//             subscriptionKey: '<insert your subscription key here>',
//             language: 'en-US',
//         },
//         variants: {
//             MicrosoftImagery: 'microsoft.imagery',
//             MicrosoftBaseDarkGrey: 'microsoft.base.darkgrey',
//             MicrosoftBaseRoad: 'microsoft.base.road',
//             MicrosoftBaseHybridRoad: 'microsoft.base.hybrid.road',
//             MicrosoftTerraMain: 'microsoft.terra.main',
//             MicrosoftWeatherInfraredMain: {
//                 url:
//                 'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
//                 '&tilesetId={variant}&x={x}&y={y}&zoom={z}'+
//                 '&timeStamp={timeStamp}&language={language}' +
//                 '&subscription-key={subscriptionKey}',
//                 options: {
//                     timeStamp: '2021-05-08T09:03:00Z',
//                     attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
//                     variant: 'microsoft.weather.infrared.main',
//                 },
//             },
//             MicrosoftWeatherRadarMain: {
//                 url:
//                 'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
//                 '&tilesetId={variant}&x={x}&y={y}&zoom={z}'+
//                 '&timeStamp={timeStamp}&language={language}' +
//                 '&subscription-key={subscriptionKey}',
//                 options: {
//                     timeStamp: '2021-05-08T09:03:00Z',
//                     attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
//                     variant: 'microsoft.weather.radar.main',
//                 },
//             }
//         },
//     },
//     SwissFederalGeoportal: {
//         url: 'https://wmts.geo.admin.ch/1.0.0/{variant}/default/current/3857/{z}/{x}/{y}.jpeg',
//         options: {
//             attribution: '&copy; <a href="https://www.swisstopo.admin.ch/">swisstopo</a>',
//             minZoom: 2,
//             maxZoom: 18,
//             bounds: [[45.398181, 5.140242], [48.230651, 11.47757]]
//         },
//         variants: {
//             NationalMapColor: 'ch.swisstopo.pixelkarte-farbe',
//             NationalMapGrey: 'ch.swisstopo.pixelkarte-grau',
//             SWISSIMAGE: {
//                 options: {
//                     variant: 'ch.swisstopo.swissimage',
//                     maxZoom: 19
//                 }
//             }
//         }
